webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__encode__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__decode__ = __webpack_require__(90);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__encode__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__decode__["a"]; });





/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_css_style_css__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_css_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_css_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_socket_io__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_socket_io___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_socket_io__);
//
//
//
//
//
//




__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_socket_io___default.a, "https://shareholderapi.inet.co.th");
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App'
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      username: '',
      password: '',
      isLoading: false,
      snackbar: false,
      y: 'top',
      x: null,
      mode: '',
      timeout: 6000,
      text: 'ยินดีต้อนรับสู่ ระบบลงคะแนนผู้ถือหุ้น'
    };
  },


  methods: {
    // // getLogin () {
    // //   this.isLoading = true
    // //   if (this.username.trim() === '') {
    // //     this.isLoading = false
    // //     this.$swal('กรุณากรอก Username', '', 'error')
    // //   } else if (this.password.trim() === '') {
    // //     this.isLoading = false
    // //     this.$swal('กรุณากรอก Password', '', 'error')
    // //   }
    // //   // $('input').blur()
    // //   this.Loading = false
    // //   // console.log('login')
    // },
    login: function login() {
      var _this = this;

      var data = {
        'username': this.username,
        'password': this.password
      };
      this.isLoading = true;
      $('input').blur();
      if (this.username.trim() === '') {
        this.isLoading = false;
        this.$swal('กรุณากรอก Username', '', 'warning');
        return;
      } else if (this.password.trim() === '') {
        this.isLoading = false;
        this.$swal('กรุณากรอก Password', '', 'warning');
        return;
      }
      this.Loading = false;

      this.axios.post("https://shareholderapi.inet.co.th" + '/login', data).then(function (response) {
        var result = response.data;
        if (result.status === 'success') {
          _this.snackbar = true;
          setTimeout(function () {
            window.location = '/';
          }, 2000);
          var information = { employeeid: result.info.employeeid, username: result.info.username, firstname: result.info.firstname, lastname: result.info.lastname };
          _this.$cookies.set('shareholder_information', __WEBPACK_IMPORTED_MODULE_0__services__["b" /* Encode */].encode(information), null, '/', Object({"NODE_ENV":"production","API":"https://shareholderapi.inet.co.th"}).DOMAIN);
          // this.$cookies.set('username_shareholder', this.username)
        } else {
          _this.isLoading = false;
          _this.$swal('', 'กรุณาตรวจสอบอีเมลและรหัสผ่านใหม่อีกครั้ง', 'error');
        }
        // this.$cookies.remove('username_inet_register')
      });
    }
    // mounted () {
    //   this.axios.get(process.env.API + '/login').then((response) => {
    //     var result = response.data
    //     if (response.status === 200) {
    //       this.username = result1
    //       console.log(result)
    //     }
    //   }
    // }

  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      drawer: null,
      items: [{ icon: 'assignment_ind', text: 'ลงทะเบียนผู้ถือหุ้น', link: '/' }, { icon: 'assignment_returned', text: 'คำนวณคะแนน', link: '/calculateScore' }, { icon: 'phone_iphone', text: 'สแกนบัตรลงคะแนน', link: '/qrscaner' }, { icon: 'language', text: 'สแกนบัตรลงคะแนนผ่านเว็บ', link: '/qrscanerweb' },
      // {
      //   icon: 'keyboard_arrow_up',
      //   'icon-alt': 'keyboard_arrow_down',
      //   text: 'Labels',
      //   model: true,
      //   children: [
      //     { icon: 'add', text: 'Create label' }
      //   ]
      // },
      { icon: 'slideshow', text: 'Presentation', link: '/presentation' },
      // { icon: 'help', text: 'Help' },
      { icon: 'insert_drive_file', text: 'สรุปผลคะแนนย้อนหลัง', link: '/resultscore' }, {
        icon: 'keyboard_arrow_up',
        'icon-alt': 'keyboard_arrow_down',
        text: 'จัดการการประชุม',
        model: false,
        children: [{ icon: 'slideshow', text: 'จัดการข้อมูลการประชุม', link: '/manageMeeting' }, { icon: 'slideshow', text: 'จัดการข้อมูลวาระ', link: '/agendaList'
          // { icon: 'slideshow', text: 'จัดการวาระการประชุม', link: '/agendaList' }
        }]
      }]
    };
  },

  computed: {
    userData: function userData() {
      if (this.$cookies.isKey('shareholder_information')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_information')));
      } else {
        return '';
      }
    }
  },
  methods: {
    logout: function logout() {
      window.location = '/login';
      this.$cookies.remove('shareholder_information', '/', Object({"NODE_ENV":"production","API":"https://shareholderapi.inet.co.th"}).DOMAIN);
      this.$cookies.remove('shareholder_termyear', '/', Object({"NODE_ENV":"production","API":"https://shareholderapi.inet.co.th"}).DOMAIN);
      // console.log(this.$cookies.isKey('username_shareholder'))
    },
    toPage: function toPage(url) {
      if (url === '/presentation') {
        window.open(url, '_blank');
      } else {
        this.$router.push(url);
      }
    }
  },
  props: {
    source: String
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedItem: {},
      shareholder: [],
      agendaList: [],
      proxyDialog: false,
      registerDialog: false,
      title: ['นาย', 'นาง', 'นางสาว'],
      proxyTitle: '',
      proxyName: '',
      proxyLastname: '',
      showInfo: false,
      errorMessages: [],
      checkProxyForm: false,
      isLoading: false,
      isLoadingRegister: false
    };
  },

  sockets: {
    getRegisterInfo: function getRegisterInfo(val) {
      this.shareholder[val.info.id - 1].info = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, val.info);
      if (this.selectedItem.info.id === val.info.id) {
        this.selectedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, val);
      }
    }
  },
  created: function created() {
    this.isLoading = true;
  },

  computed: {
    termYear: function termYear() {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_termyear')));
      } else {
        return '';
      }
    },
    userInfo: function userInfo() {
      if (this.$cookies.isKey('shareholder_information')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_information')));
      } else {
        return '';
      }
    }
  },
  methods: {
    getTermYear: function getTermYear() {
      var _this = this;

      this.axios.post("https://shareholderapi.inet.co.th" + '/getTermYearLatest').then(function (response) {
        var information = { term: response.data.term, year: response.data.year, title: response.data.title, titleEN: response.data.titleEN };
        _this.$cookies.set('shareholder_termyear', __WEBPACK_IMPORTED_MODULE_1__services__["b" /* Encode */].encode(information), null, '/', Object({"NODE_ENV":"production","API":"https://shareholderapi.inet.co.th"}).DOMAIN);
        _this.queryAgenda();
      });
    },
    queryShareholder: function queryShareholder() {
      var _this2 = this;

      this.axios.get("https://shareholderapi.inet.co.th" + '/getAllShareholder/' + this.termYear.term + '/' + this.termYear.year).then(function (response) {
        var result = response.data;
        if (response.status === 200) {
          _this2.isLoading = false;
          _this2.shareholder = result;
        }
      });
    },
    queryAgenda: function queryAgenda() {
      var _this3 = this;

      this.axios.get("https://shareholderapi.inet.co.th" + '/getAgendaInYear/' + this.termYear.term + '/' + this.termYear.year).then(function (response) {
        var result = response.data;
        if (response.status === 200) {
          _this3.agendaList = result;
          _this3.queryShareholder();
        }
      });
    },
    register: function register(registerBy) {
      var _this4 = this;

      var data = {};
      this.isLoadingRegister = true;
      if (registerBy === 'proxy') {
        if (this.proxyTitle === '' || this.proxyName === '' || this.proxyLastname === '' || this.proxyTitle === null || this.proxyName === null || this.proxyLastname === null) {
          this.checkProxyForm = true;
          this.$swal('กรุณากรอกข้อมูลให้ครบค่ะ', '', 'error');
          this.isLoadingRegister = false;
          return;
        } else {
          data = {
            'registertype': registerBy,
            'proxytitle': this.proxyTitle,
            'proxyname': this.proxyName,
            'proxylastname': this.proxyLastname,
            'memberid': this.selectedItem.info.memberid,
            'registerby': this.userInfo.username };
        }
      } else {
        // const swalWithBootstrapButtons = this.$swal.mixin({
        //   confirmButtonClass: 'btn btn-success',
        //   cancelButtonClass: 'btn btn-danger',
        //   buttonsStyling: false
        // })
        //
        // swalWithBootstrapButtons({
        //   title: 'Are you sure?',
        //   text: "You won't be able to revert this!",
        //   type: 'warning',
        //   showCancelButton: true,
        //   confirmButtonText: 'Yes, delete it!',
        //   cancelButtonText: 'No, cancel!',
        //   reverseButtons: true
        // }).then((result) => {
        //   if (result.value) {
        //     swalWithBootstrapButtons(
        //       'Deleted!',
        //       'Your file has been deleted.',
        //       'success'
        //     )
        //   } else if (
        //     // Read more about handling dismissals
        //     result.dismiss === this.$swal.DismissReason.cancel
        //   ) {
        //     swalWithBootstrapButtons(
        //       'Cancelled',
        //       'Your imaginary file is safe :)',
        //       'error'
        //     )
        //   }
        // })
        data = {
          'registertype': registerBy,
          'memberid': this.selectedItem.info.memberid,
          'registerby': this.userInfo.username };
      }

      this.axios.post("https://shareholderapi.inet.co.th" + '/register/' + this.termYear.term + '/' + this.termYear.year, data).then(function (response) {
        var result = response.data;
        if (response.status === 200) {
          if (result.status === 'success') {
            _this4.clearProxyDialog();
            _this4.proxyDialog = false;
            // this.selectedItem = Object.assign({}, { info: result.info })
            // this.selectedItem.info.register = result.info
            // this.shareholder[result.info.id - 1].info = result.info
            // this.queryShareholder()
            _this4.$socket.emit('setPresentation');
            _this4.$socket.emit('registered', { info: result.info });
          }
        }
        _this4.isLoadingRegister = false;
      });
    },
    clearProxyDialog: function clearProxyDialog() {
      // this.proxyTitle = ''
      // this.proxyName = ''
      // this.proxyLastname = ''
      // Object.keys(this.proxyTitle)[0].reset()
      // Object.keys(this.proxyName)[0].reset()
      // Object.keys(this.proxyLastname)[0].reset()
      this.$refs.form.reset();
    },
    printShareholderTemplate: function printShareholderTemplate(url, itemMember, itemAgenda) {
      this.agendatest = itemAgenda.id;
      this.nametest = itemMember.memberid;

      if (url === '/shareholdertemplate') {
        var newWindow = window.open(url + '/' + this.nametest, '_blank', 'width=1280, height=720');
        setTimeout(function () {
          newWindow.print();
        }, 1500);
      } else {
        this.$router.push(url);
      }
    },
    printProxyTemplate: function printProxyTemplate(url, itemMember, itemAgenda) {
      this.agendatest = itemAgenda.id;
      this.nametest = itemMember.memberid;
      if (url === '/proxytemplate') {
        var newWindow = window.open(url + '/' + this.nametest, '_blank', 'width=1280, height=720');
        setTimeout(function () {
          newWindow.print();
        }, 1500);
      } else {
        this.$router.push(url);
      }
    }
  },
  mounted: function mounted() {
    this.getTermYear();
  },

  watch: {
    selectedItem: function selectedItem(item) {
      this.showInfo = true;
    }
  }
});

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      imageUrl: '',
      image: null,
      radios: 'radio-1',
      dialog: false,
      headers: [{ text: 'วาระที่', align: 'left', sortable: false }, { text: 'ชื่อวาระ', value: 'agendaname', sortable: false },
      // { text: 'shortname (g)', value: 'shortname', sortable: false },
      // { text: 'Carbs (g)', value: 'carbs', sortable: false },
      // { text: 'Protein (g)', value: 'protein', sortable: false },
      { text: 'Actions', value: 'name', sortable: false }],
      desserts: [],
      agendaList: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {}
    };
  },
  computed: {
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มวาระ' : 'แก้ไขข้อมูล';
    },
    termYear: function termYear() {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_1__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_termyear')));
      } else {
        return '';
      }
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  },
  created: function created() {
    this.initialize();
  },

  methods: {
    initialize: function initialize() {
      this.desserts = [{
        agendaNum: '1',
        subAgendaNum: '',
        agendaname: 'เรื่องประธานแจ้งเพื่อทราบ (ถ้ามี)',
        shortname: ''
      }, {
        agendaNum: '2',
        subAgendaNum: '',
        agendaname: 'พิจารณารับรองรายงานการประชุมสามัญผู้ถือหุ้นประจำปี 2560 ซึ่งประชุมเมื่อวันที่ 21 เมษายน 2560 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 1)',
        shortname: ''
      }, {
        agendaNum: '3',
        subAgendaNum: '',
        agendaname: 'รับทราบรายงานคณะกรรมการบริษัทเกี่ยวกับผลการดำเนินงานประจำปี 2560 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 2)',
        shortname: ''
      }, {
        agendaNum: '4',
        subAgendaNum: '',
        agendaname: 'พิจารณาอนุมัติงบการเงินประจำปีสิ้นสุด ณ วันที่ 31 ธันวาคม 2560 ซึ่งผ่านการตรวจสอบจากผู้สอบบัญชี (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 2)',
        shortname: ''
      }, {
        agendaNum: '5',
        subAgendaNum: '',
        agendaname: 'พิจารณาจัดสรรกำไรสุทธิเป็นทุนสำรองตามกฎหมายและการจ่ายเงินปันผลสำหรับผลประกอบการประจำปี 2560',
        shortname: ''
      }, {
        agendaNum: '6',
        subAgendaNum: '',
        agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3)',
        shortname: ''
      }, {
        agendaNum: '6',
        subAgendaNum: '.1',
        agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นายอนิรุทธ์ หิรัญรักษ์',
        shortname: ''
      }, {
        agendaNum: '6',
        subAgendaNum: '.2',
        agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นางมรกต กุลธรรมโยธิน',
        shortname: ''
      }, {
        agendaNum: '6',
        subAgendaNum: '.3',
        agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นายมรกต เธียรมนตรี',
        shortname: ''
      }, {
        agendaNum: '6',
        subAgendaNum: '.4',
        agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นางสาวนฤมล วังศธรธนคุณ',
        shortname: ''
      }, {
        agendaNum: '7',
        subAgendaNum: '',
        agendaname: 'พิจารณาอนุมัติการกำหนดค่าตอบแทนกรรมการ',
        shortname: ''
      }, {
        agendaNum: '8',
        subAgendaNum: '',
        agendaname: 'พิจารณาแต่งตั้งผู้สอบบัญชีและกำหนดค่าสอบบัญชีประจำปี 2561 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 6)',
        shortname: ''
      }, {
        agendaNum: '9',
        subAgendaNum: '',
        agendaname: 'พิจารณาอนุมัติการแก้ไขข้อบังคับ บริษัท อินเทอร์เน็ตประเทศไทย จำกัด(มหาชน) ข้อ 16 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 7)',
        shortname: ''
      }, {
        agendaNum: '10',
        subAgendaNum: '',
        agendaname: 'พิจารณาเรื่องอื่นๆ (ถ้ามี)',
        shortname: ''
      }];
    },
    editItem: function editItem(item) {
      this.editedIndex = this.agendaList.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.dialog = true;
    },
    deleteItem: function deleteItem(item) {
      var _this = this;

      var index = this.agendaList.indexOf(item);
      this.$swal({
        title: '',
        text: 'คุณต้องการลบรายการที่เลือกอย่างถาวรหรือไม่',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง',
        // confirmButtonColor: 'blue',
        // cancelButtonColor: 'green',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        reverseButtons: true
      }).then(function (result) {
        if (!result.value) {
          _this.$swal('ข้อมูลถูกลบ', 'คุณได้ลบข้อมูลวาระสำเร็จแล้ว', 'success') && _this.agendaList.splice(index, 1);
        }
      });
    },

    //   confirm('Are you sure you want to delete this item?') && this.desserts.splice(index, 1)
    // },
    close: function close() {
      var _this2 = this;

      this.dialog = false;
      setTimeout(function () {
        _this2.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.defaultItem);
        _this2.editedIndex = -1;
      }, 300);
    },
    save: function save() {
      if (this.editedIndex > -1) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.agendaList[this.editedIndex], this.editedItem);
      } else {
        this.agendaList.push(this.editedItem);
      }
      this.close();
    },
    onPickFile: function onPickFile() {
      this.$refs.fileInput.click();
    },
    onFilePicked: function onFilePicked(event) {
      var _this3 = this;

      var files = event.target.files;
      var filename = files[0].name;
      if (filename.lastIndexOf('.') <= 0) {
        return alert('Please add a valid file!');
      }
      var fileReader = new FileReader();
      fileReader.addEventListener('load', function () {
        _this3.imageUrl = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.image = files[0];
    },
    queryAgenda: function queryAgenda() {
      var _this4 = this;

      this.axios.get("https://shareholderapi.inet.co.th" + '/getAgendaInYear/' + this.termYear.term + '/' + this.termYear.year).then(function (response) {
        // var result = JSON.parse(response.data)
        var result = response.data;
        if (response.status === 200) {
          _this4.agendaList = result;
        }
      });
    }
  },
  mounted: function mounted() {
    this.queryAgenda();
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      year: '',
      date: '',
      person: '',
      location: '',
      presenter: '',
      type: '',
      term: '',
      fix: '',
      meetingName: '',
      meetingNameth: '',
      dialog: false,
      headers: [{ text: '#', align: 'left', sortable: false, value: 'id' }, { text: 'ชื่อการประชุมสามัญประจำปีผู้ถือหุ้น', value: 'meetingNameTH', sortable: false }, { text: 'วัน เดือน ปี', sortable: false, value: 'agendaDate' }, { text: 'Actions', value: 'name', sortable: false }],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        limitPerson: '',
        location: '',
        presenter: '',
        type: '',
        term: '',
        fix: '',
        meetingName: '',
        meetingNameTH: '',
        agendaDate: '',
        year: ''
      },
      defaultItem: {
        limitPerson: '',
        location: '',
        presenter: '',
        type: '',
        term: '',
        fix: '',
        meetingName: '',
        meetingNameTH: '',
        agendaDate: '',
        year: ''
      }
    };
  },

  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  },
  created: function created() {
    this.initialize();
  },

  methods: {
    initialize: function initialize() {
      this.desserts = [{
        id: 1,
        limitPerson: '25',
        meetingNameTH: 'การประชุมสามัญผู้ถือหุ้นประจำปี 2561 ครั้งที่ 2',
        agendaDate: '23 เมษายน 2561',
        year: '2561'
      }, {
        id: 2,
        limitPerson: '25',
        meetingNameTH: 'การประชุมสามัญผู้ถือหุ้นประจำปี 2561 ครั้งที่ 3',
        agendaDate: '18 ตุลาคม 2561',
        year: '2561'
      }, {
        id: 3,
        limitPerson: '25',
        meetingNameTH: 'การประชุมสามัญผู้ถือหุ้นประจำปี 2562 ครั้งที่ 1',
        agendaDate: '3 มีนาคม 2562',
        year: '2562'
      }, {
        id: 4,
        limitPerson: '25',
        meetingNameTH: 'การประชุมสามัญผู้ถือหุ้นประจำปี 2562 ครั้งที่ 2',
        agendaDate: '5 พฤษภาคม 2562',
        year: '2562'
      }, {
        id: 5,
        limitPerson: '25',
        meetingNameTH: 'การประชุมสามัญผู้ถือหุ้นประจำปี 2562 ครั้งที่ 3',
        agendaDate: '11 พฤศจิกายน 2562',
        year: '2562'
      }, {
        id: 6,
        limitPerson: '25',
        meetingNameTH: 'การประชุมสามัญผู้ถือหุ้นประจำปี 2563 ครั้งที่ 1',
        agendaDate: '12 เมษายน 2563',
        year: '2563'
      }];
    },
    editItem: function editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, item);
      this.dialog = true;
    },
    deleteItem: function deleteItem(item) {
      var _this = this;

      var index = this.desserts.indexOf(item);
      this.$swal({
        title: '',
        text: 'คุณต้องการลบรายการที่เลือกอย่างถาวรหรือไม่',
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: 'ยกเลิก',
        confirmButtonText: 'ตกลง',
        // confirmButtonColor: 'blue',
        // cancelButtonColor: 'green',
        showCloseButton: true,
        showLoaderOnConfirm: true,
        reverseButtons: true
      }).then(function (result) {
        if (!result.value) {
          _this.$swal('ข้อมูลถูกลบ', 'คุณได้ลบข้อมูลวาระสำเร็จแล้ว', 'success') && _this.desserts.splice(index, 1);
        }
      });
    },
    close: function close() {
      var _this2 = this;

      this.dialog = false;
      setTimeout(function () {
        _this2.editedItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.defaultItem);
        _this2.editedIndex = -1;
      }, 300);
    },
    save: function save() {
      if (this.editedIndex > -1) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      showResultDialog: false,
      headers: [{
        text: 'วาระที่',
        align: 'left',
        sortable: false,
        value: 'name'
      }, { text: 'ชื่อวาระ', value: 'agendaname', sortable: false }, { text: 'Actions', value: 'name', sortable: false }],
      agendaInfo: [],
      agendaScore: {
        accept: '',
        noaccept: '',
        abstain: '',
        broke: ''
      },
      selectedAgenda: {},
      isLoading: false
    };
  },

  computed: {
    userData: function userData() {
      if (this.$cookies.isKey('shareholder_information')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_information')));
      } else {
        return '';
      }
    },
    termYear: function termYear() {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_termyear')));
      } else {
        return '';
      }
    }
  },
  watch: {
    dialog: function dialog(val) {
      val || this.close();
    }
  },
  created: function created() {
    this.getAgendaInYear('', '');
  },

  methods: {
    getAgendaInYear: function getAgendaInYear(type, agendaId) {
      var _this = this;

      this.axios.get("https://shareholderapi.inet.co.th" + '/getAllAgendaScore/' + this.termYear.term + '/' + this.termYear.year).then(function (response) {
        if (response.data.status === 'success') {
          _this.agendaInfo = response.data.info;
          if (type === 'showscore' && agendaId !== '') {
            for (var i = 0; i < _this.agendaInfo.length; i++) {
              if (_this.agendaInfo[i]['agenda_id'] === agendaId) {
                _this.showScore(_this.agendaInfo[i]);
              }
            }
          }
        }
      });
    },
    calculate: function calculate(item) {
      var me = this;
      this.$swal({
        title: 'คุณต้องการคำนวณคะแนน ?',
        text: 'คุณต้องการคำนวณคะแนนของวาระที่ ' + item.agenda + ' ใช่หรือไม่',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then(function () {
        var _this2 = this;

        if (me.isLoading) return;
        me.isLoading = true;
        var source = { term: me.termYear.term, year: me.termYear.year, agenda_id: item.agenda_id, createby: me.userData.username };
        me.axios.post("https://shareholderapi.inet.co.th" + '/calculateScore', source).then(function (response) {
          var result = response.data;
          if (result.status === 'fail' && result.message === 'Dont have any result from this agenda in submit table') {
            me.$swal('ไม่สามารถคำนวณคะแนนได้', 'คุณไม่ได้ทำการกรอกข้อมูลการลงคะแนนสำหรับวาระนี้ไว้ล่วงหน้า', 'error');
            me.isLoading = false;
          } else if (result.status === 'fail' && result.message === 'Dont have this agenda in agenda table') {
            me.$swal('ไม่พบวาระการประชุมนี้', '', 'error');
            me.isLoading = false;
          } else if (result.status === 'success') {
            me.getAgendaInYear('showscore', item.agenda_id);
            me.close();
            _this2.$socket.emit('setPresentation');
          }
        });
      });
    },
    fillScore: function fillScore(item) {
      this.selectedAgenda = item;
      if (item.scoreInfo.length > 0) {
        this.agendaScore.accept = item.scoreInfo[0].accept;
        this.agendaScore.noaccept = item.scoreInfo[0].noaccept;
        this.agendaScore.abstain = item.scoreInfo[0].abstain;
        this.agendaScore.broke = item.scoreInfo[0].broke;
      }
      this.dialog = true;
    },
    showScore: function showScore(item) {
      if (item.scoreInfo.length > 0) {
        this.agendaScore.accept = item.scoreInfo[0].accept;
        this.agendaScore.noaccept = item.scoreInfo[0].noaccept;
        this.agendaScore.abstain = item.scoreInfo[0].abstain;
        this.agendaScore.broke = item.scoreInfo[0].broke;
      }
      this.showResultDialog = true;
      this.isLoading = false;
    },
    close: function close() {
      this.dialog = false;
      this.showResultDialog = false;
      this.agendaScore.accept = '';
      this.agendaScore.noaccept = '';
      this.agendaScore.abstain = '';
      this.agendaScore.broke = '';
    },
    save: function save() {
      var _this3 = this;

      var source = { term: this.termYear.term, year: this.termYear.year, agenda_id: this.selectedAgenda.agenda_id, score: this.agendaScore, createby: this.userData.username };
      this.axios.post("https://shareholderapi.inet.co.th" + '/submitScore', source).then(function (response) {
        var result = response.data;
        if (result.status === 'fail' && result.message === 'Dont have this agenda in agenda table') {
          _this3.$swal('ไม่พบวาระการประชุมนี้', '', 'error');
        } else if (result.status === 'fail' && result.message === 'This agenda cannot submit score type') {
          _this3.$swal('ประเภทการคำนวณคะแนนไม่ถูกต้อง', 'คุณไม่สามารถกรอกคะแนนจากประเภทการคำนวณคะแนนนี้ได้', 'error');
        } else if (result === 'success') {
          _this3.$swal('บันทึกคะแนนเรียบร้อย', '', 'success');
        } else {
          _this3.$swal('พบข้อผิดพลาด', 'กรุณาติดต่อเจ้าหน้าที่', 'error');
        }
        _this3.getAgendaInYear('', '');
        _this3.close();
        _this3.$socket.emit('setPresentation');
      });
    },
    setQShare: function setQShare(number) {
      return number.toLocaleString(undefined, { minimumFractionDigits: 0 });
    }
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_qrcode_reader__ = __webpack_require__(55);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: { QrcodeReader: __WEBPACK_IMPORTED_MODULE_2_vue_qrcode_reader__["QrcodeReader"] },
  data: function data() {
    return {
      drawer: null,
      isValid: false,
      validating: false,
      paused: false,
      content: null,
      shareholder: [],
      items: [{ icon: 'home', text: 'Home', link: '/' }],
      nametest: []
    };
  },
  methods: {
    toPage: function toPage(url) {
      this.$router.push(url);
    },
    backPage: function backPage() {
      window.location = '/';
    },
    onDecode: function onDecode(content) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.content = content;
                _this.pauseCamera();
                _this.validating = true;
                _this.isValid = true;
                // this.isValid = await this.validate('/vote/', content)
                _this.validating = false;
                window.setTimeout(function () {
                  _this.unPauseCamera();
                }, 2000);
                if (content !== '') {
                  _this.$router.push('/vote/m' + content);
                }

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    pauseCamera: function pauseCamera() {
      this.paused = true;
    },
    unPauseCamera: function unPauseCamera() {
      this.paused = false;
    }
    // validate (url, content) {
    //   return new Promise(resolve => {
    //     this.$router.push(url + '/' + this.content)
    //     // window.setTimeout(() => { // pretend it's taking really long
    //     //   resolve(true)
    //     // }, 3000)
    //   })
    // }

  }
});

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    this.$('.btn').click(function (e) {
      e.preventDefault();
      this.$('.btn').removeClass('active');
      this.$(this).addClass('active');
    });
  }
  // methods: {
  //   chooseButton (btn) {
  //     $(btn).toggleClass('active')
  //   }
  // }

});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedItem: {},
      showInfo: false,
      dialog: false,
      selected: [],
      dropdown_font: [],
      headers: [{
        text: 'วาระที่',
        align: 'left',
        sortable: false,
        value: 'name'
      }, { text: 'ชื่อวาระ', value: 'agendaname', sortable: false }, { text: 'เห็นด้วย (เสียง)', value: 'agree', sortable: true }, { text: 'ไม่เห็นด้วย (เสียง)', value: 'disagree', sortable: true },
      // { text: 'Protein (g)', value: 'protein', sortable: false },
      { text: 'งดออกเสียง (เสียง)', value: 'discard', sortable: true }],
      datatable: [],
      editedIndex: -1
    };
  },
  watch: {
    selectedItem: function selectedItem() {
      this.showInfo = true;
    }
  },
  created: function created() {
    this.initialize();
  },

  methods: {
    initialize: function initialize() {
      this.datatable = [{
        name: '1',
        subname: '',
        agendaname: 'เรื่องประธานแจ้งเพื่อทราบ (ถ้ามี)',
        agree: 111,
        disagree: 24,
        discard: 4.0,
        year: 2008,
        test: [{
          name: '1',
          subname: '',
          agendaname: 'เรื่องประธานแจ้งเพื่อทราบ (ถ้ามี)',
          agree: 111,
          disagree: 24,
          discard: 4.0
        }, {
          name: '2',
          subname: '',
          agendaname: 'พิจารณารับรองรายงานการประชุมสามัญผู้ถือหุ้นประจำปี 2560 ซึ่งประชุมเมื่อวันที่ 21 เมษายน 2560 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 1)',
          agree: 112,
          disagree: 37,
          discard: 4.3
        }, {
          name: '3',
          subname: '',
          agendaname: 'รับทราบรายงานคณะกรรมการบริษัทเกี่ยวกับผลการดำเนินงานประจำปี 2560 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 2)',
          agree: 113,
          disagree: 23,
          discard: 6.0
        }, {
          name: '5',
          subname: '',
          agendaname: 'พิจารณาจัดสรรกำไรสุทธิเป็นทุนสำรองตามกฎหมายและการจ่ายเงินปันผลสำหรับผลประกอบการประจำปี 2560',
          agree: 115,
          disagree: 49,
          discard: 3.9
        }, {
          name: '6',
          subname: '',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3)',
          agree: 116,
          disagree: 94,
          discard: 0.0
        }, {
          name: '6.1',
          subname: '',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นายอนิรุทธ์ หิรัญรักษ์',
          agree: 117,
          disagree: 98,
          discard: 0
        }, {
          name: '6.2',
          subname: '',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นางมรกต กุลธรรมโยธิน',
          agree: 118,
          disagree: 87,
          discard: 6.5
        }, {
          name: '6.3',
          subname: '',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นายมรกต เธียรมนตรี',
          agree: 119,
          disagree: 51,
          discard: 4.9
        }, {
          name: '6.4',
          subname: '',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นางสาวนฤมล วังศธรธนคุณ',
          agree: 120,
          disagree: 65,
          discard: 7
        }, {
          name: '7',
          subname: '',
          agendaname: 'พิจารณาอนุมัติการกำหนดค่าตอบแทนกรรมการ',
          agree: 125,
          disagree: 51,
          discard: 4.9
        }, {
          name: '8',
          subname: '',
          agendaname: 'พิจารณาแต่งตั้งผู้สอบบัญชีและกำหนดค่าสอบบัญชีประจำปี 2561 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 6)',
          agree: 121,
          disagree: 51,
          discard: 4.9
        }, {
          name: '9',
          subname: '',
          agendaname: 'พิจารณาอนุมัติการแก้ไขข้อบังคับ บริษัท อินเทอร์เน็ตประเทศไทย จำกัด(มหาชน) ข้อ 16 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 7)',
          agree: 123,
          disagree: 51,
          discard: 4.9
        }, {
          name: '10',
          subname: '',
          agendaname: 'พิจารณาเรื่องอื่นๆ (ถ้ามี)',
          agree: 124,
          disagree: 51,
          discard: 4.9
        }]
      }, {
        name: '2',
        subname: '',
        agendaname: 'พิจารณารับรองรายงานการประชุมสามัญผู้ถือหุ้นประจำปี 2560 ซึ่งประชุมเมื่อวันที่ 21 เมษายน 2560 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 1)',
        agree: 112,
        disagree: 37,
        discard: 4.3,
        year: 2009,
        test: [{
          name: '1',
          subname: '',
          agendaname: 'เรื่องประธานแจ้งเพื่อทราบ (ถ้ามี)',
          agree: 111,
          disagree: 24,
          discard: 4.0
        }, {
          name: '2',
          subname: '',
          agendaname: 'พิจารณารับรองรายงานการประชุมสามัญผู้ถือหุ้นประจำปี 2560 ซึ่งประชุมเมื่อวันที่ 21 เมษายน 2560 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 1)',
          agree: 112,
          disagree: 37,
          discard: 4.3
        }, {
          name: '3',
          subname: '',
          agendaname: 'รับทราบรายงานคณะกรรมการบริษัทเกี่ยวกับผลการดำเนินงานประจำปี 2560 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 2)',
          agree: 113,
          disagree: 23,
          discard: 6.0
        }, {
          name: '5',
          subname: '',
          agendaname: 'พิจารณาจัดสรรกำไรสุทธิเป็นทุนสำรองตามกฎหมายและการจ่ายเงินปันผลสำหรับผลประกอบการประจำปี 2560',
          agree: 115,
          disagree: 49,
          discard: 3.9
        }, {
          name: '6',
          subname: '',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3)',
          agree: 116,
          disagree: 94,
          discard: 0.0
        }, {
          name: '6.1',
          subname: '',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นายอนิรุทธ์ หิรัญรักษ์',
          agree: 117,
          disagree: 98,
          discard: 0
        }, {
          name: '6.2',
          subname: '',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นางมรกต กุลธรรมโยธิน',
          agree: 118,
          disagree: 87,
          discard: 6.5
        }, {
          name: '6.3',
          subname: '',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นายมรกต เธียรมนตรี',
          agree: 119,
          disagree: 51,
          discard: 4.9
        }, {
          name: '6.4',
          subname: '',
          agendaname: 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระประจำปี 2561 (ประวัติโดยสังเขปของบุคคลที่ได้รับการเสนอชื่อเพิ่มพิจารณาเลือกตั้งเป็นกรรมการแทนกรรมการที่ออกตามวาระตามสิ่งที่ส่งมาด้วยลำดับที่ 3) นางสาวนฤมล วังศธรธนคุณ',
          agree: 120,
          disagree: 65,
          discard: 7
        }, {
          name: '7',
          subname: '',
          agendaname: 'พิจารณาอนุมัติการกำหนดค่าตอบแทนกรรมการ',
          agree: 125,
          disagree: 51,
          discard: 4.9
        }, {
          name: '8',
          subname: '',
          agendaname: 'พิจารณาแต่งตั้งผู้สอบบัญชีและกำหนดค่าสอบบัญชีประจำปี 2561 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 6)',
          agree: 121,
          disagree: 51,
          discard: 4.9
        }, {
          name: '9',
          subname: '',
          agendaname: 'พิจารณาอนุมัติการแก้ไขข้อบังคับ บริษัท อินเทอร์เน็ตประเทศไทย จำกัด(มหาชน) ข้อ 16 (รายละเอียดตามสิ่งที่ส่งมาด้วยลำดับที่ 7)',
          agree: 123,
          disagree: 51,
          discard: 4.9
        }]
      }];
    }
  }
  // mounted () {
  //   this.axios.post(process.env.API + '/getYear').then((response) => {
  //     // var result = JSON.parse(response.data)
  //     var result = response.data
  //     if (response.status === 200) {
  //       this.dropdown_font = result
  //     }
  //   })
  // }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      getItemMember: '',
      memberInfo: [],
      agendaVote: [],
      content: '',
      agendaVoteCard: [{
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 2,
        'subAgenda': '',
        'title': 'พิจารณารับรองรายงานการประชุมสามัญผู้ถือหุ้นประจำปี 2560',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 4,
        'subAgenda': '',
        'title': 'พิจารณาอนุมัติงบการเงินประจำปีสิ้นสุด ณ วันที่ 31 ธันวาคม 2560',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 5,
        'subAgenda': '',
        'title': 'พิจารณาจัดสรรกำไรสุทธิเป็นทุนสำรองตามกฎหมายและการจ่ายเงินปันผล',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 6,
        'subAgenda': 1,
        'title': 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระ นายมรกต เธียรมนตรี',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 6,
        'subAgenda': 2,
        'title': 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระ นายอนิรุทธ์ หิรัญรักษ์',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 6,
        'subAgenda': 3,
        'title': 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระ นางมรกต กุลธรรมโยธิน',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 6,
        'subAgenda': 4,
        'title': 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระ นางสาวนฤมล วังศธรธนคุณ',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 7,
        'subAgenda': '',
        'title': 'พิจารณาอนุมัติการกำหนดค่าตอบแทนกรรมการ ของวันที่ 21 เมษายน 2561',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 8,
        'subAgenda': '',
        'title': 'พิจารณาแต่งตั้งผู้สอบบัญชีและกำหนดค่าสอบบัญชีประจำปี 2561',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 9,
        'subAgenda': '',
        'title': 'พิจารณาอนุมัติการแก้ไขข้อบังคับ บริษัท อินเทอร์เน็ตประเทศไทย จำกัด(มหาชน)',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 10,
        'subAgenda': '',
        'title': 'สมมติว่ามี ชื่อวาระ เพื่อทดสอบปริ้นเตอร์ ประจำปี 2561',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 11,
        'subAgenda': '',
        'title': 'สมมติว่ามี ชื่อวาระ เพื่อทดสอบปริ้นเตอร์ ประจำปี 2561',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 12,
        'subAgenda': '',
        'title': 'สมมติว่ามี ชื่อวาระ เพื่อทดสอบปริ้นเตอร์ ประจำปี 2561',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 13,
        'subAgenda': '',
        'title': 'สมมติว่ามี ชื่อวาระ เพื่อทดสอบปริ้นเตอร์ ประจำปี 2561',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'shareholders': 662100
      }]
    };
  },

  computed: {
    userData: function userData() {
      if (this.$cookies.isKey('shareholder_information')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_information')));
      } else {
        return '';
      }
    },
    isQrExampleLastItemEnabled: function isQrExampleLastItemEnabled() {
      var targetTerm = true; // เปิดปิด qrcode เเสดงความคิดเห็น
      return targetTerm !== '' && targetTerm;
    },
    termYear: function termYear() {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_termyear')));
      } else {
        return '';
      }
    }
  },
  methods: {
    setLengthName: function setLengthName(fullname) {
      if (fullname.length > 40) {
        fullname = fullname.slice(0, 40) + '...';
      }
      return fullname;
    },
    setTableAlign: function setTableAlign(index) {
      if (index % 2 === 0) {
        return 'left';
      } else {
        return 'right';
      }
    },
    setTableStyle: function setTableStyle(index) {
      if (index % 2 === 0) {
        return ['tableLeft', { 'tableTop': index === 0 }];
      } else {
        return ['tableRight', { 'tableTop': index === 1 }];
      }
    },
    getMemberInfo: function getMemberInfo() {
      var _this = this;

      this.axios.post("https://shareholderapi.inet.co.th" + '/getShareholderInfo/' + this.termYear.term + '/' + this.termYear.year + '/' + this.getItemMember).then(function (response) {
        var result = response.data;
        _this.memberInfo = result.info;
        if (_this.memberInfo.title === 'บริษัท') {
          _this.memberInfo.fullname = 'บริษัท ' + _this.memberInfo.companyname;
        } else if (_this.memberInfo.title === '') {
          _this.memberInfo.fullname = _this.memberInfo.firstname + ' ' + _this.memberInfo.lastname;
        } else {
          _this.memberInfo.fullname = 'คุณ' + _this.memberInfo.firstname + ' ' + _this.memberInfo.lastname;
        }
        _this.getAgendaList();
      });
    },
    getAgendaList: function getAgendaList() {
      var _this2 = this;

      this.axios.get("https://shareholderapi.inet.co.th" + '/getAgendaInYearUser/' + this.termYear.term + '/' + this.termYear.year + '/' + this.getItemMember).then(function (response) {
        var result = response.data;
        _this2.agendaVote = result;
        if (_this2.agendaVote.length < 14) {
          var agendaLength = 14 - _this2.agendaVote.length;
          for (var i = 0; i < agendaLength; i++) {
            _this2.agendaVote.push({ agenda_index: '', agenda: '', short_title: '', agenda_id: '' });
          }
          if (_this2.isQrExampleLastItemEnabled && agendaLength > 0) {
            _this2.agendaVote[_this2.agendaVote.length - 1].isQrExample = true;
          }
        }
        for (var j = 0; j < _this2.agendaVote.length; j++) {
          if (!_this2.agendaVote[j].isQrExample) {
            _this2.agendaVote[j].resultAgendaID = String('0000' + _this2.agendaVote[j].agenda_id).slice(-4);
          }
        }
      });
    },
    setQShare: function setQShare(number) {
      return number.toLocaleString(undefined, { minimumFractionDigits: 0 });
    }
  },
  mounted: function mounted() {
    this.getItemMember = this.$route.params.id;
    this.getMemberInfo();
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      getItemMember: '',
      date: new Date().getFullYear() + 543,
      shareholder: [],
      memberInfo: [],
      agendaVote: [],
      processAgendaID: [],
      resultAgendaID: [],
      content: '',
      agendaVoteCard: [{
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 2,
        'subAgenda': '',
        'title': 'พิจารณารับรองรายงานการประชุมสามัญผู้ถือหุ้นประจำปี 2560',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 4,
        'subAgenda': '',
        'title': 'พิจารณาอนุมัติงบการเงินประจำปีสิ้นสุด ณ วันที่ 31 ธันวาคม 2560',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 5,
        'subAgenda': '',
        'title': 'พิจารณาจัดสรรกำไรสุทธิเป็นทุนสำรองตามกฎหมายและการจ่ายเงินปันผล',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 6,
        'subAgenda': 1,
        'title': 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระ นายมรกต เธียรมนตรี',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 6,
        'subAgenda': 2,
        'title': 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระ นายอนิรุทธ์ หิรัญรักษ์',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 6,
        'subAgenda': 3,
        'title': 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระ นางมรกต กุลธรรมโยธิน',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 6,
        'subAgenda': 4,
        'title': 'พิจารณาเลือกตั้งกรรมการแทนกรรมการที่ออกตามวาระ นางสาวนฤมล วังศธรธนคุณ',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 7,
        'subAgenda': '',
        'title': 'พิจารณาอนุมัติการกำหนดค่าตอบแทนกรรมการ ของวันที่ 21 เมษายน 2561',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 8,
        'subAgenda': '',
        'title': 'พิจารณาแต่งตั้งผู้สอบบัญชีและกำหนดค่าสอบบัญชีประจำปี 2561',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 9,
        'subAgenda': '',
        'title': 'พิจารณาอนุมัติการแก้ไขข้อบังคับ บริษัท อินเทอร์เน็ตประเทศไทย จำกัด(มหาชน)',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 10,
        'subAgenda': '',
        'title': 'สมมติว่ามี ชื่อวาระ เพื่อทดสอบปริ้นเตอร์ ประจำปี 2561',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 11,
        'subAgenda': '',
        'title': 'สมมติว่ามี ชื่อวาระ เพื่อทดสอบปริ้นเตอร์ ประจำปี 2561',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 12,
        'subAgenda': '',
        'title': 'สมมติว่ามี ชื่อวาระ เพื่อทดสอบปริ้นเตอร์ ประจำปี 2561',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }, {
        'regisNumber': 4010008296,
        'refNumber': 1001,
        'agenda': 13,
        'subAgenda': '',
        'title': 'สมมติว่ามี ชื่อวาระ เพื่อทดสอบปริ้นเตอร์ ประจำปี 2561',
        'regisName': 'วีระ เดชธำรง โดยบริษัทหลักทรัพย์จัดการกองทุน กรุงไทย จำกัด (มหาชน)',
        'regisProxyName': 'ชื่อผู้มอบฉันทะ',
        'shareholders': 662100
      }]
    };
  },

  computed: {
    userData: function userData() {
      if (this.$cookies.isKey('shareholder_information')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_information')));
      } else {
        return '';
      }
    },
    isQrExampleLastItemEnabled: function isQrExampleLastItemEnabled() {
      var targetTerm = true; // เปิดปิด qrcode เเสดงความคิดเห็น
      return targetTerm !== '' && targetTerm;
    },
    termYear: function termYear() {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_termyear')));
      } else {
        return '';
      }
    }
  },
  methods: {
    setLengthName: function setLengthName(fullname) {
      if (fullname.length > 40) {
        fullname = fullname.slice(0, 40) + '...';
      }
      return fullname;
    },
    setTableAlign: function setTableAlign(index) {
      if (index % 2 === 0) {
        return 'left';
      } else {
        return 'right';
      }
    },
    setTableStyle: function setTableStyle(index) {
      if (index % 2 === 0) {
        return ['tableLeft', { 'tableTop': index === 0 }];
      } else {
        return ['tableRight', { 'tableTop': index === 1 }];
      }
    },
    getmemberInfo: function getmemberInfo() {
      var _this = this;

      this.axios.post("https://shareholderapi.inet.co.th" + '/getShareholderInfo/' + this.termYear.term + '/' + this.termYear.year + '/' + this.getItemMember).then(function (response) {
        var result = response.data;
        _this.memberInfo = result.info;
        if (_this.memberInfo.title === 'บริษัท') {
          _this.memberInfo.fullname = 'บริษัท ' + _this.memberInfo.companyname;
        } else if (_this.memberInfo.title === '') {
          _this.memberInfo.fullname = _this.memberInfo.firstname + ' ' + _this.memberInfo.lastname;
        } else {
          _this.memberInfo.fullname = 'คุณ' + _this.memberInfo.firstname + ' ' + _this.memberInfo.lastname;
        }
        _this.memberInfo.proxyfullname = 'คุณ' + _this.memberInfo.proxyname + ' ' + _this.memberInfo.proxylastname;
        _this.getAgendaList();
      });
    },
    getAgendaList: function getAgendaList() {
      var _this2 = this;

      this.axios.get("https://shareholderapi.inet.co.th" + '/getAgendaInYearUser/' + this.termYear.term + '/' + this.termYear.year + '/' + this.getItemMember).then(function (response) {
        var result = response.data;
        _this2.agendaVote = result;
        if (_this2.agendaVote.length < 14) {
          var agendaLength = 14 - _this2.agendaVote.length;
          for (var i = 0; i < agendaLength; i++) {
            _this2.agendaVote.push({ agenda_index: '', agenda: '', short_title: '', agenda_id: '' });
          }
          if (_this2.isQrExampleLastItemEnabled && agendaLength > 0) {
            _this2.agendaVote[_this2.agendaVote.length - 1].isQrExample = true;
          }
        }
        for (var j = 0; j < _this2.agendaVote.length; j++) {
          if (!_this2.agendaVote[j].isQrExample) {
            _this2.agendaVote[j].resultAgendaID = String('0000' + _this2.agendaVote[j].agenda_id).slice(-4);
          }
        }
      });
    },
    setQShare: function setQShare(number) {
      return number.toLocaleString(undefined, { minimumFractionDigits: 0 });
    }
  },
  mounted: function mounted() {
    this.getItemMember = this.$route.params.id;
    this.getmemberInfo();
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      memberInfo: {
        firstname: '',
        lastname: '',
        q_share: ''
      },
      vote: undefined,
      agendaInfo: {
        agenda_id: '',
        agenda: '',
        agenda_title: '',
        calculatetype: ''
      },
      member_id: '',
      agenda_id: '',
      submitVote: false
    };
  },

  computed: {
    termYear: function termYear() {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_termyear')));
      } else {
        return '';
      }
    },
    qrcodeId: function qrcodeId() {
      return this.$route.params.id.slice(1, this.$route.params.id.length);
    },
    scanType: function scanType() {
      return this.$route.params.id.slice(0, 1);
    },
    userInfo: function userInfo() {
      if (this.$cookies.isKey('shareholder_information')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_information')));
      } else {
        return '';
      }
    }
  },
  created: function created() {
    this.vote = undefined;
  },

  methods: {
    setClassBG: function setClassBG() {
      return [{ 'bg': !this.isLoading }];
    },
    checkVote: function checkVote() {
      var _this = this;

      if (this.qrcodeId) {
        var id = this.qrcodeId;
        this.member_id = id.slice(0, id.length - 4);
        this.agenda_id = id.slice(-4);
      } else {
        if (this.scanType === 'w') {
          this.$router.push('/qrscanerweb');
        } else {
          this.$router.push('/qrscaner');
        }
        return;
      }
      var source = { term: this.termYear.term, year: this.termYear.year, memberid: this.member_id, agenda_id: parseInt(this.agenda_id) };
      this.axios.post("https://shareholderapi.inet.co.th" + '/checkVote', source).then(function (response) {
        _this.isLoading = false;
        var result = response.data;
        if (result.status === 'success') {
          _this.vote = result.info.memberInfo.vote;
          _this.agendaInfo.agenda_title = result.info.agendaInfo.short_title;
          _this.agendaInfo.agenda_index = result.info.agendaInfo.agenda_index;
          _this.agendaInfo.agenda = result.info.agendaInfo.agenda;
          _this.agendaInfo.agenda_id = result.info.agendaInfo.agenda_id;
          _this.memberInfo.memberid = result.info.memberInfo.memberid;
          _this.memberInfo.firstname = result.info.memberInfo.firstname;
          _this.memberInfo.lastname = result.info.memberInfo.lastname;
          _this.memberInfo.proxyname = result.info.memberInfo.proxyname;
          _this.memberInfo.proxylastname = result.info.memberInfo.proxylastname;
          _this.memberInfo.q_share = result.info.memberInfo.q_share;
        } else if (result.status === 'fail' && result.message === 'Not found memberid') {
          _this.$swal('ไม่พบข้อมูลผู้ถือหุ้น', '', 'error');
          if (_this.scanType === 'w') {
            _this.$router.push('/qrscanerweb');
          } else {
            _this.$router.push('/qrscaner');
          }
        } else if (result.status === 'fail' && result.message === 'Not found agenda_id') {
          _this.$swal('ไม่พบข้อมูลวาระการประชุม', '', 'error');
          if (_this.scanType === 'w') {
            _this.$router.push('/qrscanerweb');
          } else {
            _this.$router.push('/qrscaner');
          }
        } else {
          _this.$swal('ไม่พบข้อมูล', 'กรุณาติดต่อเจ้าหน้าที่', 'error');
          if (_this.scanType === 'w') {
            _this.$router.push('/qrscanerweb');
          } else {
            _this.$router.push('/qrscaner');
          }
        }
      });
    },
    saveData: function saveData() {
      var _this2 = this;

      if (!this.vote || this.submitVote) {
        return;
      }
      this.submitVote = true;
      var source = { term: this.termYear.term, year: this.termYear.year, memberid: this.member_id, agenda_id: parseInt(this.agenda_id), vote: this.vote, createby: this.userInfo.username };
      this.axios.post("https://shareholderapi.inet.co.th" + '/vote', source).then(function (response) {
        var me = _this2;
        if (response.data.status === 'success') {
          _this2.submitVote = false;
          _this2.$swal({
            title: 'บันทึกข้อมูลแล้ว',
            type: 'success'
          }).then(function () {
            me.$router.push('/vote/' + me.scanType + me.qrcodeId + '/submit');
            this.vote = undefined;
          });
        } else {
          _this2.vote = undefined;
          _this2.$swal('ไม่สามารถลงคะแนนไต้', 'กรุณาติดต่อเจ้าหน้าที่', 'error');
          _this2.submitVote = false;
        }
      });
    },
    cancel: function cancel() {
      if (this.scanType === 'w') {
        this.$router.push('/qrscanerweb');
      } else {
        this.$router.push('/qrscaner');
      }
      localStorage.removeItem('content');
    },
    setQShare: function setQShare(number) {
      return number.toLocaleString(undefined, { minimumFractionDigits: 0 });
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.isLoading = true;
    this.vote = undefined;
    this.checkVote();
    window.addEventListener('keyup', function (event) {
      if (event.keyCode === 49) {
        _this3.vote = 'เห็นด้วย';
      } else if (event.keyCode === 50) {
        _this3.vote = 'ไม่เห็นด้วย';
      } else if (event.keyCode === 51) {
        _this3.vote = 'งดออกเสียง';
      } else if (event.keyCode === 52) {
        _this3.vote = 'บัตรเสีย';
      }
      // } else if (event.keyCode === 13) {
      //   // if (this.vote) {
      //   //   this.saveData()
      //   // }
      //   this.saveData()
      // }
    });
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      memberInfo: {
        firstname: '',
        lastname: '',
        q_share: ''
      },
      vote: '',
      agendaInfo: {
        agenda_id: '',
        agenda: '',
        agenda_title: '',
        calculatetype: ''
      },
      member_id: '',
      agenda_id: ''
    };
  },
  created: function created() {
    this.isLoading = true;
    this.checkVote();
  },

  computed: {
    termYear: function termYear() {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_termyear')));
      } else {
        return '';
      }
    },
    qrcodeId: function qrcodeId() {
      return this.$route.params.id.slice(1, this.$route.params.id.length);
    },
    scanType: function scanType() {
      return this.$route.params.id.slice(0, 1);
    }
  },
  methods: {
    setClassBG: function setClassBG() {
      return [{ 'bg': !this.isLoading }];
    },
    checkVote: function checkVote() {
      var _this = this;

      if (this.qrcodeId) {
        var id = this.qrcodeId;
        this.member_id = id.slice(0, id.length - 4);
        this.agenda_id = id.slice(-4);
      } else {
        if (this.scanType === 'w') {
          this.$router.push('/qrscanerweb');
        } else {
          this.$router.push('/qrscaner');
        }
        return;
      }
      var source = { term: this.termYear.term, year: this.termYear.year, memberid: this.member_id, agenda_id: parseInt(this.agenda_id) };
      this.axios.post("https://shareholderapi.inet.co.th" + '/checkVote', source).then(function (response) {
        _this.isLoading = false;
        var result = response.data;
        if (result.status === 'success') {
          _this.vote = result.info.memberInfo.vote;
          _this.agendaInfo.agenda_title = result.info.agendaInfo.short_title;
          _this.agendaInfo.agenda = result.info.agendaInfo.agenda;
          _this.agendaInfo.agenda_id = result.info.agendaInfo.agenda_id;
          _this.memberInfo.memberid = result.info.memberInfo.memberid;
          _this.memberInfo.firstname = result.info.memberInfo.firstname;
          _this.memberInfo.lastname = result.info.memberInfo.lastname;
          _this.memberInfo.q_share = result.info.memberInfo.q_share;
        } else if (result.status === 'fail' && result.message === 'Not found memberid') {
          _this.$swal('ไม่พบข้อมูลผู้ถือหุ้น', '', 'error');
          if (_this.scanType === 'w') {
            _this.$router.push('/qrscanerweb');
          } else {
            _this.$router.push('/qrscaner');
          }
        } else if (result.status === 'fail' && result.message === 'Not found agenda_id') {
          _this.$swal('ไม่พบข้อมูลวาระการประชุม', '', 'error');
          if (_this.scanType === 'w') {
            _this.$router.push('/qrscanerweb');
          } else {
            _this.$router.push('/qrscaner');
          }
        } else {
          _this.$swal('ไม่พบข้อมูล', 'กรุณาติดต่อเจ้าหน้าที่', 'error');
          if (_this.scanType === 'w') {
            _this.$router.push('/qrscanerweb');
          } else {
            _this.$router.push('/qrscaner');
          }
        }
      });
    },
    editData: function editData() {
      this.$router.push('/vote/' + this.scanType + this.qrcodeId);
    },
    cancel: function cancel() {
      if (this.scanType === 'w') {
        this.$router.push('/qrscanerweb');
      } else {
        this.$router.push('/qrscaner');
      }
    },
    setQShare: function setQShare(number) {
      return number.toLocaleString(undefined, { minimumFractionDigits: 0 });
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loader: null,
      loading: false,
      loading2: false,
      loading3: false,
      loading4: false
    };
  },

  watch: {
    loader: function loader() {
      var _this = this;

      var l = this.loader;
      this[l] = !this[l];
      setTimeout(function () {
        return _this[l] = false;
      }, 3000);
      this.loader = null;
    }
  },
  methods: {
    editData: function editData() {
      window.location = '/qrcode/shareholderid';
    },
    cancel: function cancel() {
      window.location = '/manageAgenda';
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loader: null,
      loading: false,
      loading2: false,
      loading3: false,
      loading4: false
    };
  },

  watch: {
    loader: function loader() {
      var _this = this;

      var l = this.loader;
      this[l] = !this[l];
      setTimeout(function () {
        return _this[l] = false;
      }, 3000);
      this.loader = null;
    }
  },
  methods: {
    editData: function editData() {
      window.location = '/qrcode/shareholderid';
    },
    cancel: function cancel() {
      window.location = '/manageAgenda';
    }
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loader: null,
      loading: false,
      loading2: false,
      loading3: false,
      loading4: false
    };
  },

  watch: {
    loader: function loader() {
      var _this = this;

      var l = this.loader;
      this[l] = !this[l];
      setTimeout(function () {
        return _this[l] = false;
      }, 3000);
      this.loader = null;
    }
  },
  methods: {
    editData: function editData() {
      window.location = '/qrcode/shareholderid';
    },
    cancel: function cancel() {
      window.location = '/manageAgenda';
    }
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isLoading: false,
      // arr: ['page1', 'page2', 'page3', 'page4', 'page5', 'page6', 'page7', 'page8', 'page9', 'page10', 'page11', 'page12', 'page13'],
      entrie: [{
        'shareholders': '500,041,575',
        'personshareholders': '3,991',
        'regisshareholders': '272,143,752',
        'percent': '54.42',
        'regisperson': '84',
        'membershareholders': '53',
        'proxyshareholders': '31'
      }],
      meetingInfo: {},
      agendaVote: [],
      page: 1
    };
  },

  sockets: {
    showPresentation: function showPresentation() {
      this.getInfo();
    }
  },
  computed: {
    userData: function userData() {
      if (this.$cookies.isKey('shareholder_information')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_information')));
      } else {
        return '';
      }
    },
    termYear: function termYear() {
      if (this.$cookies.isKey('shareholder_termyear')) {
        return JSON.parse(__WEBPACK_IMPORTED_MODULE_0__services__["a" /* Decode */].decode(this.$cookies.get('shareholder_termyear')));
      } else {
        return '';
      }
    },
    setDate: function setDate() {
      var someDate = new Date();
      return someDate.toLocaleDateString('th-TH', { day: 'numeric', month: 'long', year: 'numeric' });
    }
  },
  created: function created() {
    this.isLoading = true;
    this.getInfo();
  },

  methods: {
    setColor: function setColor(data, type) {
      if (type === 'qshare') {
        if (this.meetingInfo.min_qshare > data) {
          return ['red--text f-r meetingInfoFont'];
        } else {
          return ['green--text f-r meetingInfoFont'];
        }
      } else {
        if (this.meetingInfo.min_member > data) {
          return ['red--text f-r meetingInfoFont'];
        } else {
          return ['green--text f-r meetingInfoFont'];
        }
      }
    },
    setColorVote: function setColorVote(data, type) {
      if (type === 'qshare') {
        if (this.meetingInfo.min_qshare > data) {
          return ['red--text'];
        } else {
          return ['green--text'];
        }
      } else {
        if (this.meetingInfo.min_member > data) {
          return ['red--text'];
        } else {
          return ['green--text'];
        }
      }
    },
    nextItem: function nextItem() {
      if (this.page === this.agendaVote.length + 3) {
        this.page = 1;
      } else {
        this.page = this.page + 1;
      }
    },
    prevItem: function prevItem() {
      if (this.page === 1) {
        this.page = this.agendaVote.length + 3;
      } else {
        this.page = this.page - 1;
      }
    },
    getInfo: function getInfo() {
      var _this = this;

      var source = { term: this.termYear.term, year: this.termYear.year };
      this.axios.post("https://shareholderapi.inet.co.th" + '/getPresentationInfo', source).then(function (response) {
        var result = response.data;
        console.log(result);
        if (result.status === 'success') {
          _this.meetingInfo = result.info;
          _this.agendaVote = result.agenda;
          _this.isLoading = false;
        } else {
          _this.isLoading = false;
        }
      });
    },
    setPercent: function setPercent(number, type) {
      if (type === 'agenda') {
        if (number === '0.0000..') {
          return number;
        } else if (number === 0) {
          return '0.0000';
          // return 0
        }
        return parseFloat(number).toFixed(4);
      } else {
        if (number === '0.00..') {
          return number;
        } else if (number === 0) {
          return 0;
          // return 0
        }
        return parseFloat(number).toFixed(2);
      }
    },
    setQShare: function setQShare(number) {
      return number.toLocaleString(undefined, { minimumFractionDigits: 0 });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    window.addEventListener('keyup', function (event) {
      if (event.keyCode === 37) {
        _this2.prevItem();
      } else if (event.keyCode === 39) {
        _this2.nextItem();
      }
    });
    window.addEventListener('click', this.nextItem);
  }
  // beforeDestroy () {
  //   window.removeEventListener('click', this.nextItem)
  // }

});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedItem: {},
      qrcodefullid: null,
      memberInfo: [],
      showInfo: false,
      nametest: []
    };
  },

  methods: {
    toPage: function toPage(url) {
      this.$router.push(url);
    },
    submit: function submit(url) {
      // var item = this.qrcodefullid
      // console.log(item)
      // this.nametest.push(this.qrcodefullid.slice(0, this.qrcodefullid.length - 4))
      // this.nametest.push(this.qrcodefullid.slice(-4))
      // var memberid = item.slice(0, 10)
      // var agendaid = item.slice(10, 14)
      // this.testmemberid = memberid
      // this.testagendaid = agendaid
      // --------------------------------------------------------------------------
      // localStorage.setItem('content', this.nametest)
      // localStorage.setItem('itemAgendaid', this.testagendaid)
      if (url === '/vote/w') {
        // var newWindow = window.open(url + this.qrcodefullid, '_blank')
        // console.log(newWindow)
        this.$router.push(url + this.qrcodefullid);
        // setTimeout(function () { window.location.reload() }, 10)
      } else {
        this.$router.push(url + this.qrcodefullid);
      }
      // #after submit clear value
      this.qrcodefullid = '';

      // console.log(memberid)
      // console.log(agendaid)
      // var test = { 'memberid': this.qrcodefullid }
      // var data = { 'memberid': this.qrcodefullid }

      // this.axios.post('http://localhost:5000' + '/showScanMember', data).then((response) => {
      //   var result = response.data
      //   console.log(result)
      //   this.memberInfo = result
      //   $('input').blur()
      //   if (response.status === 200) {
      //     if (result.status === 'success') {
      //       this.$swal('สำเร็จ !', 'ทำรายการสำเร็จ', 'success')
      //     } else {
      //       this.$swal('ผิดพลาด !', 'ไม่มีข้อมูลกรุณากรอกข้อมูลใหม่', 'error')
      //     }
      //   }
      // })
    },
    reset: function reset() {
      this.qrcodefullid = '';
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js__);
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({

    props: {
        text: { type: String, required: true },
        size: { type: Number, required: false, default: 256 },
        color: { type: String, required: false, default: '#000' },
        bgColor: { type: String, required: false, default: '#FFF' },
        errorLevel: {
            type: String,
            validator: function validator(value) {
                return value === 'L' || value === 'M' || value === 'Q' || value === 'H';
            },
            required: false,
            default: 'H'
        }
    },

    watch: {
        text: function text() {
            this.clear();
            this.makeCode(this.text);
        }
    },

    data: function data() {
        return {
            qrCode: {}
        };
    },
    mounted: function mounted() {
        this.qrCode = new __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a(this.$el, {
            text: this.text,
            width: this.size,
            height: this.size,
            colorDark: this.color,
            colorLight: this.bgColor,
            correctLevel: __WEBPACK_IMPORTED_MODULE_0_qrcode_js_package_qrcode_js___default.a.CorrectLevel[this.errorLevel]
        });
    },


    methods: {
        clear: function clear() {
            this.qrCode.clear();
        },
        makeCode: function makeCode(text) {
            this.qrCode.makeCode(text);
        }
    }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_sweetalert__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_sweetalert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_sweetalert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_axios__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookies__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_cookies___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_cookies__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_qrcode_reader__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_qrcode_component__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_swiper_dist_css_swiper_css__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_swiper_dist_css_swiper_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_sweetalert___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_6_axios___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_cookies___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_10_vue_qrcode_reader__["default"]);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].component('qr-code', __WEBPACK_IMPORTED_MODULE_11_vue_qrcode_component__["a" /* default */]);

window.$ = __webpack_provided_window_dot_jQuery = __webpack_require__(18);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>'
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(18)))

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f50e46d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(82);
function injectStyle (ssrContext) {
  __webpack_require__(78)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f50e46d8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */,
/* 80 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login_Login__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ManageAgenda__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_contents_RegisterShareholder__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contents_AgendaList__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_contents_ManageMeeting__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_contents_CalculateScore__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_QRScaner__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Selection__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_contents_ResultScore__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Pdf_Shareholdertemplate__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Pdf_Proxytemplate__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Mobile_Scanqrcode__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Mobile_Submitqrcode__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Mobile_test1__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Mobile_test2__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Mobile_test3__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Pdf_Presentation__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_QRScanerWeb__ = __webpack_require__(183);





















__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{ path: '/login', component: __WEBPACK_IMPORTED_MODULE_2__components_Login_Login__["a" /* default */] }, { path: '/manageAgenda', component: __WEBPACK_IMPORTED_MODULE_3__components_ManageAgenda__["a" /* default */], meta: { requiresAuth: true } }, { path: '/selection', component: __WEBPACK_IMPORTED_MODULE_9__components_Selection__["a" /* default */] }, { path: '/shareholdertemplate/:id', component: __WEBPACK_IMPORTED_MODULE_11__components_Pdf_Shareholdertemplate__["a" /* default */] }, { path: '/proxytemplate/:id', component: __WEBPACK_IMPORTED_MODULE_12__components_Pdf_Proxytemplate__["a" /* default */] }, { path: '/vote/:id', component: __WEBPACK_IMPORTED_MODULE_13__components_Mobile_Scanqrcode__["a" /* default */] }, { path: '/vote/:id/submit', component: __WEBPACK_IMPORTED_MODULE_14__components_Mobile_Submitqrcode__["a" /* default */] }, { path: '/qrcode/shareholderid/test1', component: __WEBPACK_IMPORTED_MODULE_15__components_Mobile_test1__["a" /* default */] }, { path: '/qrcode/shareholderid/test2', component: __WEBPACK_IMPORTED_MODULE_16__components_Mobile_test2__["a" /* default */] }, { path: '/qrcode/shareholderid/test3', component: __WEBPACK_IMPORTED_MODULE_17__components_Mobile_test3__["a" /* default */] }, { path: '/presentation', component: __WEBPACK_IMPORTED_MODULE_18__components_Pdf_Presentation__["a" /* default */], meta: { requiresAuth: true } }, { path: '/',
    component: __WEBPACK_IMPORTED_MODULE_3__components_ManageAgenda__["a" /* default */],
    meta: { requiresAuth: true },
    children: [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_4__components_contents_RegisterShareholder__["a" /* default */] }, { path: '/agendaList', component: __WEBPACK_IMPORTED_MODULE_5__components_contents_AgendaList__["a" /* default */] }, { path: '/manageMeeting', component: __WEBPACK_IMPORTED_MODULE_6__components_contents_ManageMeeting__["a" /* default */] }, { path: '/calculateScore', component: __WEBPACK_IMPORTED_MODULE_7__components_contents_CalculateScore__["a" /* default */] }, { path: '/resultscore', component: __WEBPACK_IMPORTED_MODULE_10__components_contents_ResultScore__["a" /* default */] }, { path: '/qrscaner', component: __WEBPACK_IMPORTED_MODULE_8__components_QRScaner__["a" /* default */] }, { path: '/qrscanerweb', component: __WEBPACK_IMPORTED_MODULE_19__components_QRScanerWeb__["a" /* default */]
      // { path: '/register/:id', component: register },
      // { path: '/all', component: all },
      // { path: '/newaccount', component: newaccount },
      // { path: '/resendMail', component: resendMail }
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (x) {
    return x.meta.requiresAuth;
  })) {
    if (!window.$cookies.isKey('shareholder_information')) {
      next({ path: '/login' });
    } else {
      next();
    }
    return;
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (x) {
    return x.meta.isAuth;
  })) {
    if (window.$cookies.isKey('shareholder_information')) {
      next({ path: '/' });
    } else {
      next();
    }
    return;
  }
  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15cf7219_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(91);
function injectStyle (ssrContext) {
  __webpack_require__(86)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-15cf7219"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15cf7219_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 86 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var encode = function encode(data) {
  return reverse(btoa(unescape(encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data))))) + randomString(5);
};
function reverse(s) {
  return s.split('').reverse().join('');
}

function randomString(num) {
  var text = '';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < num; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  encode: encode
});

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var decode = function decode(data) {
  return decodeURIComponent(escape(atob(reverse(data.slice(0, -5)))));
};
function reverse(s) {
  return s.split('').reverse().join('');
}
/* harmony default export */ __webpack_exports__["a"] = ({
  decode: decode
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('div',{staticClass:"vertical-center"},[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm8":"","md4":""}},[_c('div',{staticClass:"text-xs-center"},[_c('img',{attrs:{"src":"/static/img/icons/logo.png","height":"180px"}})]),_vm._v(" "),_c('v-card',{staticClass:"elevation-24",attrs:{"color":"grey lighten-3"}},[_c('v-toolbar',{attrs:{"dark":"","color":"green"}},[_c('v-toolbar-title',[_vm._v("INET Shareholder Meeting")])],1),_vm._v(" "),_c('v-card-text',[_c('v-form',[_c('v-text-field',{attrs:{"autocapitalize":"off","prepend-icon":"person","color":"amber accent-4","name":"login","label":"ชื่อผู้ใช้งาน","type":"text","autocomplete":"off"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login()}},model:{value:(_vm.username),callback:function ($$v) {_vm.username=$$v},expression:"username"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","color":"amber accent-4","name":"password","label":"รหัสผ่าน","id":"password","type":"password"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login()}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"widthfull",attrs:{"round":"","depressed":"","color":"success"},nativeOn:{"click":function($event){return _vm.login.apply(null, arguments)}}},[_c('v-icon',{staticClass:"pr-2"},[_vm._v("lock")]),_vm._v("เข้าสู่ระบบ\n                ")],1),_vm._v(" "),_c('v-snackbar',{attrs:{"top":_vm.y === 'top'},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(" "+_vm._s(_vm.text))])],1),_vm._v(" "),_c('v-footer',{staticClass:"pa-3",attrs:{"color":"blue-grey darken-1"}},[_c('v-flex',{attrs:{"xs12":"","py-3":"","text-xs-center":"","white--text":""}},[_vm._v("\n                  © "+_vm._s(new Date().getFullYear())+" INET\n                ")])],1)],1)],1)],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageAgenda_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_568c0c1b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageAgenda_vue__ = __webpack_require__(94);
function injectStyle (ssrContext) {
  __webpack_require__(93)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-568c0c1b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageAgenda_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_568c0c1b_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageAgenda_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-navigation-drawer',{attrs:{"dark":"","fixed":"","clipped":_vm.$vuetify.breakpoint.lgAndUp,"app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.items),function(item){return [(item.heading)?_c('v-layout',{key:item.heading,attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs6":""}},[(item.heading)?_c('v-subheader',[_vm._v("\n              "+_vm._s(item.heading)+"\n            ")]):_vm._e()],1)],1):(item.children)?_c('v-list-group',{key:item.text,attrs:{"prepend-icon":item.model ? item.icon : item['icon-alt'],"append-icon":""},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(item.text)+"\n              ")])],1)],1),_vm._v(" "),_vm._l((item.children),function(child,i){return _c('v-list-tile',{key:i,staticClass:"child-padding",on:{"click":function($event){return _vm.toPage(child.link)}}},[(child.icon)?_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(child.icon))])],1):_vm._e(),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(child.text)+"\n              ")])],1)],1)})],2):_c('v-list-tile',{key:item.text,on:{"click":function($event){return _vm.toPage(item.link)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n              "+_vm._s(item.text)+"\n            ")])],1)],1)]})],2)],1),_vm._v(" "),_c('v-toolbar',{attrs:{"color":"blue darken-3","dark":"","app":"","clipped-left":_vm.$vuetify.breakpoint.lgAndUp,"fixed":""}},[_c('v-toolbar-title',{staticClass:"ml-0 pl-3",staticStyle:{"width":"300px"}},[_c('v-toolbar-side-icon',{on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('span',[_vm._v("INET Shareholder")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',[_c('h3',[_vm._v(_vm._s(_vm.userData.username))])]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"indigo"},on:{"click":function($event){return _vm.logout()}},slot:"activator"},[_c('v-icon',[_vm._v("power_settings_new")])],1),_vm._v(" "),_c('span',[_vm._v("ลงชื่อออก")])],1)],1),_vm._v(" "),_c('v-content',[_c('router-view')],1),_vm._v(" "),_c('v-footer',{staticClass:"pa-3 shareholder-footer",attrs:{"color":"primary"}},[_c('v-flex',{attrs:{"xs12":"","py-3":"","text-xs-center":"","white--text":""}},[_vm._v("\n      © "+_vm._s(new Date().getFullYear())+" Internet Thailand Public Company Limited\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterShareholder_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e205092_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterShareholder_vue__ = __webpack_require__(107);
function injectStyle (ssrContext) {
  __webpack_require__(96)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e205092"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RegisterShareholder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e205092_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RegisterShareholder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 96 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"regiterationLayout text-xs-center"},[_c('v-progress-circular',{attrs:{"size":70,"width":5,"indeterminate":"","color":"primary"}})],1):_c('div',{staticClass:"regiterationLayout text-xs-center"},[_c('h1',{staticStyle:{"font-weight":"900","font-size":"2.3em"}},[_vm._v("ลงทะเบียนเข้างาน")]),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('h2',{staticClass:"titleOfTextfield"},[_vm._v("ค้นหา")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('v-select',{ref:"shareholder",attrs:{"items":_vm.shareholder,"item-value":"shareholder.info","autocomplete":"","label":"","placeholder":"ชื่อ / นามสกุล / บริษัท / เลขผู้ถือหุ้น","required":""},model:{value:(_vm.selectedItem),callback:function ($$v) {_vm.selectedItem=$$v},expression:"selectedItem"}})],1)],1),_vm._v(" "),(_vm.showInfo)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showInfo),expression:"showInfo"}],staticClass:"formInfo"},[_c('div',{staticClass:"infoDiv"},[(_vm.isLoadingRegister)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{attrs:{"size":70,"width":5,"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),(!_vm.isLoadingRegister)?_c('div',[_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItem.info.title != 'บริษัท' ),expression:"selectedItem.info.title != 'บริษัท' "}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('h3',[_vm._v("ชื่อ-นามสกุล :")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm7":""}},[_c('h3',[_vm._v(_vm._s(_vm.selectedItem.info.title)+" "+_vm._s(_vm.selectedItem.info.firstname)+" "+_vm._s(_vm.selectedItem.info.lastname))])]),_vm._v(" "),(_vm.selectedItem.info.proxyname == null)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","sm3":""}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItem.info.register != 0),expression:"selectedItem.info.register != 0"}],staticStyle:{"width":"100% height:60px","font-weight":"bold"},attrs:{"color":"primary darken-2","dark":""},on:{"click":function($event){return _vm.printShareholderTemplate('/shareholdertemplate', _vm.selectedItem.info, _vm.selectedItem.info)}}},[_vm._v("พิมพ์บัตรลงคะแนน")])],1):_vm._e(),_vm._v(" "),(_vm.selectedItem.info.proxyname != null)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","sm3":""}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItem.info.register != 0),expression:"selectedItem.info.register != 0"}],staticStyle:{"width":"100% height:60px","font-weight":"bold"},attrs:{"color":"primary darken-2","dark":""},on:{"click":function($event){return _vm.printProxyTemplate('/proxytemplate', _vm.selectedItem.info, _vm.selectedItem.info)}}},[_vm._v("พิมพ์บัตรลงคะแนน")])],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItem.info.title == 'บริษัท' ),expression:"selectedItem.info.title == 'บริษัท' "}],staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('h3',[_vm._v("ชื่อบริษัท :")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm7":""}},[_c('h3',[_vm._v(_vm._s(_vm.selectedItem.info.companyname)+" ")])]),_vm._v(" "),(_vm.selectedItem.info.proxyname == null)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","sm3":""}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItem.info.register != 0),expression:"selectedItem.info.register != 0"}],staticStyle:{"width":"100% height:60px","font-weight":"bold"},attrs:{"color":"primary darken-2","dark":""},on:{"click":function($event){return _vm.printShareholderTemplate('/shareholdertemplate', _vm.selectedItem.info, _vm.selectedItem.info)}}},[_vm._v("พิมพ์บัตรลงคะแนน")])],1):_vm._e(),_vm._v(" "),(_vm.selectedItem.info.proxyname != null)?_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","sm3":""}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItem.info.register != 0),expression:"selectedItem.info.register != 0"}],staticStyle:{"width":"100% height:60px","font-weight":"bold"},attrs:{"color":"primary darken-2","dark":""},on:{"click":function($event){return _vm.printProxyTemplate('/proxytemplate', _vm.selectedItem.info, _vm.selectedItem.info)}}},[_vm._v("พิมพ์บัตรลงคะแนน")])],1):_vm._e()],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('h3',[_vm._v("จำนวนหุ้น")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('h3',[_vm._v(_vm._s(_vm.selectedItem.info.q_share.toLocaleString()))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":""}},[_c('h3',[_vm._v("หุ้น")])])],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItem.info.proxyname != null ),expression:"selectedItem.info.proxyname != null "}],staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('h3',[_vm._v("ชื่อ-นามสกุลผู้มอบฉันทะ:")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm7":""}},[_c('h3',[_vm._v(_vm._s(_vm.selectedItem.info.proxytitle)+" "+_vm._s(_vm.selectedItem.info.proxyname)+" "+_vm._s(_vm.selectedItem.info.proxylastname))])])],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('h3',[_vm._v("สถานะ :")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItem.info.register == 0),expression:"selectedItem.info.register == 0"}]},[_vm._v("ยังไม่ได้ลงทะเบียน")]),_vm._v(" "),_c('h3',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItem.info.register != 0),expression:"selectedItem.info.register != 0"}]},[_vm._v("ลงทะเบียนแล้ว")])])],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs12":"","sm12":""}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItem.info.register == 0),expression:"selectedItem.info.register == 0"}],staticStyle:{"width":"100% height:60px","font-weight":"bold"},attrs:{"large":"","color":"amber darken-2","dark":"","depressed":""},on:{"click":function($event){$event.stopPropagation();_vm.proxyDialog = true}}},[_vm._v("ผู้รับมอบฉันทะ")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItem.info.register != 0),expression:"selectedItem.info.register != 0"}],staticStyle:{"width":"100% height:60px","font-weight":"bold"},attrs:{"large":"","disabled":""},on:{"click":function($event){$event.stopPropagation();_vm.proxyDialog = true}}},[_vm._v("ผู้รับมอบฉันทะ")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItem.info.register == 0),expression:"selectedItem.info.register == 0"}],staticStyle:{"width":"100% height:60px","background-color":"#61C356"},attrs:{"large":"","dark":"","depressed":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.registerDialog = true}}},[_vm._v("ลงทะเบียน")]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedItem.info.register != 0),expression:"selectedItem.info.register != 0"}],staticStyle:{"width":"100% height:60px"},attrs:{"large":"","disabled":""}},[_vm._v("ลงทะเบียน")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"width":"60%"},model:{value:(_vm.proxyDialog),callback:function ($$v) {_vm.proxyDialog=$$v},expression:"proxyDialog"}},[_c('v-form',{ref:"form"},[_c('v-card',[_c('v-card-title',[_c('h2',[_vm._v("ลงทะเบียนแบบมอบฉันทะ")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"pd5",attrs:{"xs12":"","sm2":""}},[_c('v-select',{ref:"proxyTitle",attrs:{"items":_vm.title,"autocomplete":"","label":"","placeholder":"คำนำหน้า","rules":[function () { return !!_vm.proxyTitle || 'This field is required'; }],"required":""},model:{value:(_vm.proxyTitle),callback:function ($$v) {_vm.proxyTitle=$$v},expression:"proxyTitle"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pd5",attrs:{"xs12":"","sm5":""}},[_c('v-text-field',{ref:"proxyName",attrs:{"label":"ชื่อ","rules":[function () { return !!_vm.proxyName || 'This field is required'; }],"required":""},model:{value:(_vm.proxyName),callback:function ($$v) {_vm.proxyName=$$v},expression:"proxyName"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"pd5",attrs:{"xs12":"","sm5":""}},[_c('v-text-field',{ref:"proxyLastname",attrs:{"label":"นามสกุล","rules":[function () { return !!_vm.proxyLastname || 'This field is required'; }],"required":""},model:{value:(_vm.proxyLastname),callback:function ($$v) {_vm.proxyLastname=$$v},expression:"proxyLastname"}})],1)],1),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('v-btn',{staticStyle:{"width":"100% height:60px"},attrs:{"large":""},on:{"click":[_vm.clearProxyDialog,function($event){$event.stopPropagation();_vm.proxyDialog=false}]}},[_vm._v("ย้อนกลับ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}}),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"right"},attrs:{"xs12":"","sm2":""}},[_c('v-btn',{staticStyle:{"width":"100% height:60px"},attrs:{"large":"","color":"success"},on:{"click":function($event){return _vm.register("proxy")}}},[_vm._v("ลงทะเบียน")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.registerDialog),callback:function ($$v) {_vm.registerDialog=$$v},expression:"registerDialog"}},[_c('v-card',[_c('v-card-title'),_vm._v(" "),_c('v-card-text',{staticStyle:{"text-align":"center"}},[_c('h2',[_vm._v("ยืนยันการลงทะเบียนผู้ถือหุ้น")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},nativeOn:{"click":function($event){_vm.registerDialog = false}}},[_vm._v("ย้อนกลับ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":function($event){return _vm.register('simple')}},nativeOn:{"click":function($event){_vm.registerDialog = false}}},[_vm._v("ยืนยัน")])],1)],1)],1)],1)],1)]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgendaList_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae0644_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgendaList_vue__ = __webpack_require__(110);
function injectStyle (ssrContext) {
  __webpack_require__(109)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b5ae0644"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AgendaList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b5ae0644_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AgendaList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mt-4",staticStyle:{"text-align":"center","font-size":"2.3em"}},[_vm._v("จัดการข้อมูลวาระการประชุมครั้งที่ 2 ปี 2018")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{staticClass:"mb-3",attrs:{"slot":"activator","color":"primary","dark":""},slot:"activator"},[_vm._v("เพิ่มวาระ")]),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"วาระที่","required":""},model:{value:(_vm.editedItem.agenda_index),callback:function ($$v) {_vm.$set(_vm.editedItem, "agenda_index", $$v)},expression:"editedItem.agenda_index"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"วาระย่อย"},model:{value:(_vm.editedItem.agenda),callback:function ($$v) {_vm.$set(_vm.editedItem, "agenda", $$v)},expression:"editedItem.agenda"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"ชื่อวาระ","required":""},model:{value:(_vm.editedItem.title),callback:function ($$v) {_vm.$set(_vm.editedItem, "title", $$v)},expression:"editedItem.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"ชื่อวาระย่อ","hint":"ใช้สำหรับพิมพ์ชื่อวาระที่มีความยาวเกินไป"},model:{value:(_vm.editedItem.short_title),callback:function ($$v) {_vm.$set(_vm.editedItem, "short_title", $$v)},expression:"editedItem.short_title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('h2',[_vm._v("รูปภาพ")]),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"raised":""},on:{"click":_vm.onPickFile}},[_vm._v("Upload Image")]),_vm._v(" "),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*"},on:{"change":_vm.onFilePicked}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('img',{attrs:{"src":_vm.imageUrl,"height":"80"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h2',[_vm._v("การนับคะแนน")]),_vm._v(" "),_c('v-radio-group',{attrs:{"mandatory":false},model:{value:(_vm.radios),callback:function ($$v) {_vm.radios=$$v},expression:"radios"}},[_c('v-radio',{attrs:{"label":"เสียงข้างมาก","value":"radio-1"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"เสียงไม่น้อยกว่าสามในสี่","value":"radio-2"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.close.apply(null, arguments)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("Save")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.agendaList},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.agenda_index)+"."+_vm._s(props.item.agenda))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.title))]),_vm._v(" "),_c('td',{staticClass:"justify-right layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n      Lignes "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n    ")]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.initialize}},[_vm._v("Reset")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageMeeting_vue__ = __webpack_require__(45);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f85a0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageMeeting_vue__ = __webpack_require__(113);
function injectStyle (ssrContext) {
  __webpack_require__(112)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-71f85a0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ManageMeeting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71f85a0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ManageMeeting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mt-4",staticStyle:{"text-align":"center","font-size":"2.3em"}},[_vm._v("จัดการข้อมูลการประชุมครั้งที่ 2 ปี 2018")]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"850px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"slot":"activator","color":"primary","dark":""},slot:"activator"},[_vm._v("เพิ่มการประชุมครั้งถัดไป")]),_vm._v(" "),_c('v-card',[_c('v-container',{staticClass:"outerDiv"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md8":"","offset-md2":""}},[_c('div',{staticClass:"loginDiv",staticStyle:{"text-align":"right"}},[_c('div',{staticClass:"centerDiv"},[_c('img',{staticClass:"LogoInet",attrs:{"src":"/static/img/icons/logo.jpg","alt":""}})]),_vm._v(" "),_c('h1',{staticClass:"mb-4 mt-1",staticStyle:{"text-align":"center","font-size":"2.3em"}},[_vm._v("ข้อมูลการประชุมครั้งที่ 2 ปี 2018")]),_vm._v(" "),_c('v-layout',{staticClass:"pl-3 pr-3",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("Value")]),_vm._v(" "),_c('v-text-field',{staticClass:"input-group--focused",attrs:{"hint":"this_year","single-line":""},model:{value:(_vm.editedItem.year),callback:function ($$v) {_vm.$set(_vm.editedItem, "year", $$v)},expression:"editedItem.year"}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-group--focused",attrs:{"hint":"agenda_date","single-line":""},model:{value:(_vm.editedItem.date),callback:function ($$v) {_vm.$set(_vm.editedItem, "date", $$v)},expression:"editedItem.date"}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-group--focused",attrs:{"hint":"limit_person","single-line":""},model:{value:(_vm.editedItem.limitPerson),callback:function ($$v) {_vm.$set(_vm.editedItem, "limitPerson", $$v)},expression:"editedItem.limitPerson"}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-group--focused",attrs:{"hint":"location","single-line":""},model:{value:(_vm.editedItem.location),callback:function ($$v) {_vm.$set(_vm.editedItem, "location", $$v)},expression:"editedItem.location"}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-group--focused",attrs:{"hint":"presenter","single-line":""}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-group--focused",attrs:{"hint":"type","single-line":""},model:{value:(_vm.editedItem.type),callback:function ($$v) {_vm.$set(_vm.editedItem, "type", $$v)},expression:"editedItem.type"}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-group--focused",attrs:{"hint":"term","single-line":""},model:{value:(_vm.editedItem.term),callback:function ($$v) {_vm.$set(_vm.editedItem, "term", $$v)},expression:"editedItem.term"}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-group--focused",attrs:{"hint":"fix","single-line":""},model:{value:(_vm.editedItem.fix),callback:function ($$v) {_vm.$set(_vm.editedItem, "fix", $$v)},expression:"editedItem.fix"}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-group--focused",attrs:{"hint":"meetingName","value":"Annual General Meet","single-line":""}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-group--focused",attrs:{"hint":"meetingName_th","single-line":""},model:{value:(_vm.editedItem.meetingNameTH),callback:function ($$v) {_vm.$set(_vm.editedItem, "meetingNameTH", $$v)},expression:"editedItem.meetingNameTH"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("Detail")]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"this_year","placeholder":"ปีที่ประชุมผู้ถือหุ้น","disabled":""}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"agenda_date","placeholder":"วันที่ประชุมผู้ถือหุ้น","disabled":""}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"limit_person","placeholder":"จำนวนผู้ลงทะเบียนผู้ถือหุ้น(ขั้นต่ำ)","disabled":""}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"location","placeholder":"สถานที่ประชุมผู้ถือหุ้น","disabled":""}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"presenter","placeholder":"name of presenter","disabled":""}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"type","placeholder":"1=เสียงข้างมาก 2=เสียง 3 ใน 4","disabled":""}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"term","placeholder":"ครั้งที่","disabled":""}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"fix","placeholder":"วาระที่ต้องการใส่รูป","disabled":""}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"meetingName","placeholder":"ชื่อวาระประชุมภาษาอังกฤษ","disabled":""}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"meetingName_th","placeholder":"ชื่อการประชุมภาษาไทย","disabled":""}})],1)],1)],1)])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.close.apply(null, arguments)}}},[_vm._v("ยกเลิก")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("เพิ่มการประชุมครั้งถัดไป")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.desserts},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.meetingNameTH))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.agendaDate))]),_vm._v(" "),_c('td',{staticClass:"justify-right layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.initialize}},[_vm._v("Reset")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalculateScore_vue__ = __webpack_require__(46);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7769a19e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalculateScore_vue__ = __webpack_require__(116);
function injectStyle (ssrContext) {
  __webpack_require__(115)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7769a19e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CalculateScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7769a19e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CalculateScore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_c('div',{staticClass:"text-xs-center loadingClass"},[_c('v-progress-circular',{attrs:{"size":70,"width":5,"indeterminate":"","color":"primary"}})],1):_vm._e(),_vm._v(" "),_c('h1',{staticClass:"mt-5",staticStyle:{"text-align":"center","font-size":"2.3em"}},[_vm._v("ผลคะแนนวาระการประชุมครั้งที่ "+_vm._s(_vm.termYear.term)+" ปี "+_vm._s(_vm.termYear.year))]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 mb-5",attrs:{"headers":_vm.headers,"items":_vm.agendaInfo,"rows-per-page-items":[8,15,25,{'text':'All','value':-1}]},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.agenda))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.title))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{attrs:{"small":"","round":"","outline":"","color":"primary","disabled":props.item.calculatetype === 1},on:{"click":function($event){return _vm.fillScore(props.item)}}},[_vm._v("กรอกคะแนน")]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","round":"","outline":"","color":"secondary"},on:{"click":function($event){return _vm.calculate(props.item)}}},[_vm._v("คำนวณคะแนน")])],1)]}},{key:"pageText",fn:function(props){return [_vm._v("\n      "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" of "+_vm._s(props.itemsLength)+"\n    ")]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.getAgendaInYear('', '')}}},[_vm._v("Reset")])],1)],2),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"300px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("บันทึกคะแนน")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"เห็นด้วย","type":"number","min":"0","disabled":""},model:{value:(_vm.agendaScore.accept),callback:function ($$v) {_vm.$set(_vm.agendaScore, "accept", $$v)},expression:"agendaScore.accept"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"ไม่เห็นด้วย","type":"number","min":"0"},model:{value:(_vm.agendaScore.noaccept),callback:function ($$v) {_vm.$set(_vm.agendaScore, "noaccept", $$v)},expression:"agendaScore.noaccept"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"งดออกเสียง","type":"number","min":"0"},model:{value:(_vm.agendaScore.abstain),callback:function ($$v) {_vm.$set(_vm.agendaScore, "abstain", $$v)},expression:"agendaScore.abstain"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"บัตรเสีย","type":"number","min":"0"},model:{value:(_vm.agendaScore.broke),callback:function ($$v) {_vm.$set(_vm.agendaScore, "broke", $$v)},expression:"agendaScore.broke"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.close.apply(null, arguments)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.save.apply(null, arguments)}}},[_vm._v("Update")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"300px"},model:{value:(_vm.showResultDialog),callback:function ($$v) {_vm.showResultDialog=$$v},expression:"showResultDialog"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("ผลการคำนวณคะแนน")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs5":"","offset-xs1":""}},[_c('span',[_vm._v("เห็นด้วย :")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-right",attrs:{"xs5":""}},[_c('span',[_vm._v(_vm._s(_vm.setQShare(_vm.agendaScore.accept)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","offset-xs1":""}},[_c('span',[_vm._v("ไม่เห็นด้วย :")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-right",attrs:{"xs5":""}},[_c('span',[_vm._v(_vm._s(_vm.setQShare(_vm.agendaScore.noaccept)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","offset-xs1":""}},[_c('span',[_vm._v("งดออกเสียง :")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-right",attrs:{"xs5":""}},[_c('span',[_vm._v(_vm._s(_vm.setQShare(_vm.agendaScore.abstain)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":"","offset-xs1":""}},[_c('span',[_vm._v("บัตรเสีย :")])]),_vm._v(" "),_c('v-flex',{staticClass:"text-right",attrs:{"xs5":""}},[_c('span',[_vm._v(_vm._s(_vm.setQShare(_vm.agendaScore.broke)))])])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.close.apply(null, arguments)}}},[_vm._v("Close")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRScaner_vue__ = __webpack_require__(47);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea0d40b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRScaner_vue__ = __webpack_require__(152);
function injectStyle (ssrContext) {
  __webpack_require__(118)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ea0d40b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRScaner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea0d40b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRScaner_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('QrcodeReader',{attrs:{"paused":_vm.paused},on:{"decode":_vm.onDecode}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.paused),expression:"paused"}],staticClass:"validation-layer"},[_c('div',{staticClass:"decode-result"},[_c('u',[_vm._v("ถอดรหัส QRCODE")]),_vm._v(": "+_vm._s(_vm.content)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"validation-notice"},[(_vm.validating)?_c('div',[_vm._v("\n              กำลังประมวลผล...\n            ")]):(_vm.isValid)?_c('div',{staticClass:"text-success"},[_vm._v("\n              สำเร็จ\n            ")]):_c('div',{staticClass:"text-danger"},[_vm._v("\n              โปรดสแกน QRCODE ใหม่อีกครั้ง\n            ")])])]),_vm._v(" "),_c('LoadingIndicator')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Selection_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c164e7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Selection_vue__ = __webpack_require__(155);
function injectStyle (ssrContext) {
  __webpack_require__(154)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c164e7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Selection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c164e7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Selection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 154 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"inspire"}},[_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":"","hidden-lg-and-up":""}},[_c('v-toolbar',{attrs:{"color":"indigo","dark":"","fixed":"","app":""}},[_c('v-toolbar-title',[_vm._v("Shareholder Meeting")])],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":"","align-center":""}},[_c('v-flex',{attrs:{"text-xs-center":"","justify-center":""}},[_c('div',{staticClass:"center"},[_c('v-btn',{staticClass:"bt-choice",attrs:{"large":"","color":"green lighten-2"}},[_vm._v("เห็นด้วย")]),_vm._v(" "),_c('v-btn',{staticClass:"bt-choice",attrs:{"large":"","color":"green lighten-1"}},[_vm._v("ไม่เห็นด้วย")]),_vm._v(" "),_c('v-btn',{staticClass:"bt-choice",attrs:{"large":"","color":"green lighten-3"}},[_vm._v("งดออกเสียง")]),_vm._v(" "),_c('v-btn',{staticClass:"bt-choice",attrs:{"large":"","color":"lime darken-1"}},[_vm._v("บัตรเสีย")]),_vm._v(" "),_c('v-flex',{attrs:{"text-xs-right":""}},[_c('div',[_c('v-btn',{attrs:{"flat":"","color":"primary"}},[_vm._v("ยืนยัน")])],1)])],1)])],1),_vm._v(" "),_c('v-footer',{attrs:{"app":"","color":"grey lighten-3"}},[_vm._v("\n            INET\n          ")])],1),_vm._v(" "),_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":"","hidden-md-and-down":"","hidden-md-only":""}},[_c('v-flex',{attrs:{"lg6":"","offset-lg3":""}},[_c('v-card',{staticClass:"elevation-18"},[_c('v-toolbar',{attrs:{"dark":""}},[_c('v-toolbar-title',[_vm._v("Shareholder Meeting")])],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"lg4":"","offset-lg4":""}},[_c('v-btn',{staticClass:"btn",attrs:{"block":"","color":"green darken-1"}},[_vm._v("เห็นด้วย")])],1),_vm._v(" "),_c('v-flex',{attrs:{"lg4":"","offset-lg4":""}},[_c('v-btn',{staticClass:"btn",attrs:{"block":"","color":"green darken-1"}},[_vm._v("ไม่เห็นด้วย")])],1),_vm._v(" "),_c('v-flex',{attrs:{"lg4":"","offset-lg4":""}},[_c('v-btn',{staticClass:"btn",attrs:{"block":"","color":"green darken-1","green":"","darken-1":""}},[_vm._v("งดออกเสียง")])],1),_vm._v(" "),_c('v-flex',{attrs:{"lg4":"","offset-lg4":""}},[_c('v-btn',{staticClass:"btn",attrs:{"block":"","color":"green darken-1","green":"","darken-1":""}},[_vm._v("บัตรเสีย")])],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"black"}},[_vm._v("ยืนยัน")])],1),_vm._v(" "),_c('v-footer',[_c('v-flex',{attrs:{"text-xs-center":""}},[_c('v-spacer'),_vm._v("\n               © "+_vm._s(new Date().getFullYear())+" INET\n               ")],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultScore_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fd9af0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultScore_vue__ = __webpack_require__(158);
function injectStyle (ssrContext) {
  __webpack_require__(157)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9fd9af0a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ResultScore_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9fd9af0a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ResultScore_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mt-5",staticStyle:{"text-align":"center","font-size":"2.3em"}},[_vm._v("ผลคะแนนของวาระการประชุมครั้งที่ 2 ปี 2018")]),_vm._v(" "),_c('v-flex',{staticClass:"ml-4",attrs:{"xs5":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.datatable,"item-value":"item","item-text":"year","overflow":"","label":"Select"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.selected.test},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.agendaname))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.agree))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.disagree))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.discard))])]}},{key:"pageText",fn:function(props){return [_vm._v("\n      Lignes "+_vm._s(props.pageStart)+" - "+_vm._s(props.pageStop)+" de "+_vm._s(props.itemsLength)+"\n    ")]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.initialize}},[_vm._v("Reset")])],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shareholdertemplate_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6883321d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shareholdertemplate_vue__ = __webpack_require__(161);
function injectStyle (ssrContext) {
  __webpack_require__(160)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6883321d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Shareholdertemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6883321d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Shareholdertemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"size":"A4"}},[_c('div',_vm._l((_vm.agendaVote),function(item,index){return _c('table',{class:[_vm.setTableStyle(index), {'qrcodeExampleTable': item.isQrExample}],attrs:{"align":_vm.setTableAlign(index)}},[(item.isQrExample)?_c('tbody',[_c('tr',[_c('td',{staticClass:"qrcodeExampleCell",attrs:{"colspan":"4"}},[_c('div',{staticClass:"qrcodeExampleContent"},[_c('img',{staticClass:"qrcodeExampleImage",attrs:{"src":"/static/img/icons/QRCodeEX.jpg","alt":"QR code example"}}),_vm._v(" "),_c('div',{staticClass:"qrcodeExampleText"},[_vm._v("แสดงความคิดเห็นหรือซักถาม "),_c('br'),_c('br'),_vm._v(" สแกน QR Code ระบบคำถาม")])])])])]):_c('tbody',[_c('tr',[_c('th',{attrs:{"rowspan":"2"}},[_c('qr-code',{staticStyle:{"margin":"10% 5%"},attrs:{"size":"50","error-level":"L","text":_vm.content=_vm.memberInfo.memberid + item.resultAgendaID}})],1),_vm._v(" "),_c('th',{attrs:{"colspan":"3"}},[_vm._v("การประชุมสามัญผู้ถือหุ้นประจำปี "+_vm._s(_vm.termYear.year))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold","background-color":"#E8E8E8"}},[_c('div',[_vm._v("\n              วาระที่ "+_vm._s(item.agenda)+"\n            ")])]),_vm._v(" "),_c('td',{staticClass:"tablea",staticStyle:{"font-weight":"bold","text-align":"left","background-color":"#E8E8E8"}},[_vm._v("\n            "+_vm._s(item.short_title)+"\n          ")])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"rowspan":"2"}},[_c('span',{staticStyle:{"font-weight":"bold","padding-top":"0px","font-size":"6px"}},[_vm._v(_vm._s(_vm.memberInfo.memberid)+_vm._s(item.resultAgendaID))]),_vm._v(" "),_c('span',{staticStyle:{"margin-bottom":"0px","font-weight":"bold"}},[_vm._v("เลขทะเบียน")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.memberInfo.memberid))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"height":"84.5px","table-layout":"auto"}},[_c('span',{staticStyle:{"padding-top":"10px","padding-bottom":"5px","text-align":"right"}},[_c('img',{staticClass:"imgckbox",attrs:{"src":"/static/img/icons/ckbox.gif"}}),_vm._v("\n              เห็นด้วย\n            ")]),_vm._v(" "),_c('span',{staticStyle:{"padding-top":"10px","padding-bottom":"5px","text-align":"right"}},[_c('img',{staticClass:"imgckbox",attrs:{"src":"/static/img/icons/ckbox.gif"}}),_vm._v("\n              ไม่เห็นด้วย\n            ")]),_vm._v(" "),_c('span',{staticStyle:{"padding-top":"10px","text-align":"right"}},[_c('img',{staticClass:"imgckbox",attrs:{"src":"/static/img/icons/ckbox.gif"}}),_vm._v("\n              งดออกเสียง\n            ")])]),_vm._v(" "),_c('td',{staticClass:"tablea",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.setLengthName(_vm.memberInfo.fullname)))]),_vm._v(" "),_c('span',{staticStyle:{"text-align":"left"}},[_vm._v("จำนวนหุ้น "+_vm._s(_vm.setQShare(_vm.memberInfo.q_share)))]),_vm._v(" "),_c('span',{staticStyle:{"text-align":"left"}},[_vm._v("ลงชื่อ _____________(ผู้ถือหุ้น)")])])])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proxytemplate_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03b4c454_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Proxytemplate_vue__ = __webpack_require__(164);
function injectStyle (ssrContext) {
  __webpack_require__(163)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-03b4c454"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proxytemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_03b4c454_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Proxytemplate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"size":"A4"}},[_c('div',_vm._l((_vm.agendaVote),function(item,index){return _c('table',{class:[_vm.setTableStyle(index), {'qrcodeExampleTable': item.isQrExample}],attrs:{"align":_vm.setTableAlign(index)}},[(item.isQrExample)?_c('tbody',[_c('tr',[_c('td',{staticClass:"qrcodeExampleCell",attrs:{"colspan":"4"}},[_c('div',{staticClass:"qrcodeExampleContent"},[_c('img',{staticClass:"qrcodeExampleImage",attrs:{"src":"/static/img/icons/QRCodeEX.jpg","alt":"QR code example"}}),_vm._v(" "),_c('div',{staticClass:"qrcodeExampleText"},[_vm._v("แสดงความคิดเห็นหรือซักถาม "),_c('br'),_c('br'),_vm._v(" สแกน QR Code ระบบคำถาม")])])])])]):_c('tbody',[_c('tr',[_c('th',{attrs:{"rowspan":"2"}},[_c('qr-code',{staticStyle:{"margin":"9% 5%"},attrs:{"size":"50","error-level":"L","text":_vm.content=_vm.memberInfo.memberid + item.resultAgendaID}})],1),_vm._v(" "),_c('th',{attrs:{"colspan":"3"}},[_vm._v("การประชุมสามัญผู้ถือหุ้นประจำปี "+_vm._s(_vm.termYear.year))])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"font-weight":"bold","background-color":"#E8E8E8"}},[_vm._v("\n            วาระที่ "+_vm._s(item.agenda)+"\n          ")]),_vm._v(" "),_c('td',{staticClass:"tablea",staticStyle:{"font-weight":"bold","text-align":"left","background-color":"#E8E8E8"}},[_vm._v("\n            "+_vm._s(item.short_title)+"\n          ")])]),_vm._v(" "),_c('tr',[_c('td',{attrs:{"rowspan":"2"}},[_c('span',{staticStyle:{"font-weight":"bold","padding-top":"0px","font-size":"6px"}},[_vm._v(_vm._s(_vm.memberInfo.memberid)+_vm._s(item.resultAgendaID))]),_vm._v(" "),_c('span',{staticStyle:{"margin-bottom":"0px","font-weight":"bold"}},[_vm._v("เลขทะเบียน")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.memberInfo.memberid))])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"height":"84.5px","table-layout":"auto"}},[_c('span',{staticStyle:{"padding-top":"10px","padding-bottom":"5px","text-align":"right"}},[_c('img',{staticClass:"imgckbox",attrs:{"src":"/static/img/icons/ckbox.gif"}}),_vm._v("\n              เห็นด้วย\n            ")]),_vm._v(" "),_c('span',{staticStyle:{"padding-top":"10px","padding-bottom":"5px","text-align":"right"}},[_c('img',{staticClass:"imgckbox",attrs:{"src":"/static/img/icons/ckbox.gif"}}),_vm._v("\n              ไม่เเห็นด้วย\n            ")]),_vm._v(" "),_c('span',{staticStyle:{"padding-top":"10px","text-align":"right"}},[_c('img',{staticClass:"imgckbox",attrs:{"src":"/static/img/icons/ckbox.gif"}}),_vm._v("\n              งดออกเสียง\n            ")])]),_vm._v(" "),_c('td',{staticClass:"tablea",staticStyle:{"text-align":"left"}},[_c('span',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.setLengthName(_vm.memberInfo.fullname)))]),_vm._v(" "),_c('span',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(_vm.setLengthName(_vm.memberInfo.proxyfullname)))]),_vm._v(" "),_c('span',{staticStyle:{"text-align":"left"}},[_vm._v("จำนวนหุ้น "+_vm._s(_vm.setQShare(_vm.memberInfo.q_share)))]),_vm._v(" "),_c('span',{staticStyle:{"text-align":"left"}},[_vm._v("ลงชื่อ ________________________(ผู้รับมอบฉันทะ)")])])])])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scanqrcode_vue__ = __webpack_require__(61);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc73d3c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scanqrcode_vue__ = __webpack_require__(167);
function injectStyle (ssrContext) {
  __webpack_require__(166)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cc73d3c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Scanqrcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc73d3c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Scanqrcode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.setClassBG()},[(_vm.isLoading)?_c('div',{staticClass:"loadingLayout text-xs-center"},[_c('v-progress-circular',{attrs:{"size":70,"width":5,"indeterminate":"","color":"black"}})],1):_c('v-container',[_c('section',[_c('v-layout',{staticClass:"white--text border",attrs:{"column":"","align-center":"","justify-center":""}},[_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"xs12":"","md12":""}},[_c('h1',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v("วาระที่ "+_vm._s(_vm.agendaInfo.agenda)+" "+_vm._s(_vm.agendaInfo.agenda_title))]),_vm._v(" "),_c('h2',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v(_vm._s(_vm.memberInfo.firstname)+" "+_vm._s(_vm.memberInfo.lastname))]),_vm._v(" "),(_vm.memberInfo.proxyname !== null)?_c('h2',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v("ผู้มอบฉันทะ "+_vm._s(_vm.memberInfo.proxyname)+" "+_vm._s(_vm.memberInfo.proxylastname))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"subheading mb-3 text-xs-center"},[_vm._v("จำนวนหุ้น "+_vm._s(_vm.setQShare(_vm.memberInfo.q_share))+" หุ้น")])]),_vm._v(" "),_c('v-flex',{staticClass:"hidden-md-and-up",attrs:{"xs12":"","md12":""}},[_c('h4',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v("วาระที่ "+_vm._s(_vm.agendaInfo.agenda))]),_vm._v(" "),_c('h5',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v(_vm._s(_vm.agendaInfo.agenda_title))]),_vm._v(" "),_c('h5',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v(_vm._s(_vm.memberInfo.firstname)+" "+_vm._s(_vm.memberInfo.lastname))]),_vm._v(" "),(_vm.memberInfo.proxyname !== null)?_c('h5',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v("ผู้มอบฉันทะ "+_vm._s(_vm.memberInfo.proxyname)+" "+_vm._s(_vm.memberInfo.proxylastname))]):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"mb-3 text-xs-center"},[_vm._v("จำนวนหุ้น "+_vm._s(_vm.setQShare(_vm.memberInfo.q_share))+" หุ้น")])]),_vm._v(" "),(_vm.submitVote)?_c('div',{staticClass:"loadingLayout text-xs-center"},[_c('v-progress-circular',{attrs:{"size":70,"width":5,"indeterminate":"","color":"white"}})],1):_vm._e(),_vm._v(" "),(!_vm.submitVote)?_c('v-flex',{staticClass:"py-2",attrs:{"xs12":"","sm6":""}},[_c('v-btn-toggle',{staticStyle:{"background":"transparent"},model:{value:(_vm.vote),callback:function ($$v) {_vm.vote=$$v},expression:"vote"}},[_c('v-btn',{staticClass:"grey darken-2 mt-3 white--text",attrs:{"round":"","dark":"","large":"","value":"เห็นด้วย"}},[_vm._v("\n              เห็นด้วย\n            ")]),_vm._v(" "),_c('v-btn',{staticClass:"grey darken-2 mt-3 white--text",attrs:{"round":"","dark":"","large":"","value":"ไม่เห็นด้วย"}},[_vm._v("\n              ไม่เห็นด้วย\n            ")]),_vm._v(" "),_c('v-btn',{staticClass:"grey darken-2 mt-3 white--text",attrs:{"round":"","dark":"","large":"","value":"งดออกเสียง"}},[_vm._v("\n              งดออกเสียง\n            ")]),_vm._v(" "),_c('v-btn',{staticClass:"grey darken-2 mt-3 white--text",attrs:{"round":"","dark":"","large":"","value":"บัตรเสีย"}},[_vm._v("\n              บัตรเสีย\n            ")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.submitVote)?_c('v-flex',{attrs:{"xs6":"","md6":""}},[_c('v-btn',{staticClass:"red darken-4 mr-2 mt-4",attrs:{"dark":""},nativeOn:{"click":function($event){return _vm.cancel.apply(null, arguments)}}},[_vm._v("ยกเลิก")]),_vm._v(" "),_c('v-btn',{staticClass:"primary darken-4 mt-4",attrs:{"dark":""},nativeOn:{"click":function($event){return _vm.saveData.apply(null, arguments)}}},[_vm._v("บันทึก")])],1):_vm._e()],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Submitqrcode_vue__ = __webpack_require__(62);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3af16167_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Submitqrcode_vue__ = __webpack_require__(170);
function injectStyle (ssrContext) {
  __webpack_require__(169)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3af16167"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Submitqrcode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3af16167_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Submitqrcode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 169 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.setClassBG()},[(_vm.isLoading)?_c('div',{staticClass:"loadingLayout text-xs-center"},[_c('v-progress-circular',{attrs:{"size":70,"width":5,"indeterminate":"","color":"black"}})],1):_c('v-container',{staticClass:"centerDiv"},[_c('section',[_c('v-layout',{staticClass:"white--text border",attrs:{"column":"","align-center":"","justify-center":""}},[_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"xs12":"","md12":""}},[_c('h1',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v("วาระที่ "+_vm._s(_vm.agendaInfo.agenda)+" "+_vm._s(_vm.agendaInfo.agenda_title))]),_vm._v(" "),_c('h2',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v(_vm._s(_vm.memberInfo.firstname)+" "+_vm._s(_vm.memberInfo.lastname))]),_vm._v(" "),_c('div',{staticClass:"subheading mb-3 text-xs-center"},[_vm._v("จำนวนหุ้น "+_vm._s(_vm.setQShare(_vm.memberInfo.q_share))+" หุ้น")])]),_vm._v(" "),_c('v-flex',{staticClass:"hidden-md-and-up",attrs:{"xs12":"","md12":""}},[_c('h4',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v("วาระที่ "+_vm._s(_vm.agendaInfo.agenda))]),_vm._v(" "),_c('h5',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v(_vm._s(_vm.agendaInfo.agenda_title))]),_vm._v(" "),_c('h5',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v(_vm._s(_vm.memberInfo.firstname)+" "+_vm._s(_vm.memberInfo.lastname))]),_vm._v(" "),_c('h5',{staticClass:"mb-3 text-xs-center"},[_vm._v("จำนวนหุ้น "+_vm._s(_vm.setQShare(_vm.memberInfo.q_share))+" หุ้น")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"mt-3 mb-3"},[_vm._v("ลงคะแนน : "+_vm._s(_vm.vote))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{staticClass:"success darken-4 mr-1 mt-3",attrs:{"dark":""},nativeOn:{"click":function($event){return _vm.cancel.apply(null, arguments)}}},[_vm._v("กลับไปหน้าแรก")]),_vm._v(" "),_c('v-btn',{staticClass:"primary darken-4 mt-3",attrs:{"dark":""},nativeOn:{"click":function($event){return _vm.editData.apply(null, arguments)}}},[_vm._v("แก้ไข")])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test1_vue__ = __webpack_require__(63);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f490bf4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_test1_vue__ = __webpack_require__(173);
function injectStyle (ssrContext) {
  __webpack_require__(172)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1f490bf4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f490bf4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_test1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-content',{staticClass:"centerDiv"},[_c('section',[_c('v-layout',{staticClass:"white--text border",attrs:{"column":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v("ชื่อผู้ถือหุ้น")]),_vm._v(" "),_c('h1',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v("ชื่อวาระ (แสดงชื่อย่อ)")]),_vm._v(" "),_c('div',{staticClass:"subheading mb-3 text-xs-center"},[_vm._v("จำนวนหุ้น")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"mt-5 mb-5"},[_vm._v("ลงคะแนน : ไม่เห็นด้วย")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{staticClass:"success darken-4 mr-2 mt-5",attrs:{"loading":_vm.loading4,"disabled":_vm.loading4,"round":"","dark":""},nativeOn:{"click":function($event){return _vm.cancel.apply(null, arguments)}}},[_vm._v("กลับไปหน้าแรก")]),_vm._v(" "),_c('v-btn',{staticClass:"primary darken-4 mt-5",attrs:{"round":"","dark":""},nativeOn:{"click":function($event){return _vm.editData.apply(null, arguments)}}},[_vm._v("แก้ไข")])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test2_vue__ = __webpack_require__(64);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e60cf1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_test2_vue__ = __webpack_require__(176);
function injectStyle (ssrContext) {
  __webpack_require__(175)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35e60cf1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35e60cf1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_test2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-content',{staticClass:"centerDiv"},[_c('section',[_c('v-layout',{staticClass:"white--text border",attrs:{"column":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v("ชื่อผู้ถือหุ้น")]),_vm._v(" "),_c('h1',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v("ชื่อวาระ (แสดงชื่อย่อ)")]),_vm._v(" "),_c('div',{staticClass:"subheading mb-3 text-xs-center"},[_vm._v("จำนวนหุ้น")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"mt-5 mb-5"},[_vm._v("ลงคะแนน : งดออกเสียง")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{staticClass:"success darken-4 mr-2 mt-5",attrs:{"loading":_vm.loading4,"disabled":_vm.loading4,"round":"","dark":""},nativeOn:{"click":function($event){return _vm.cancel.apply(null, arguments)}}},[_vm._v("กลับไปหน้าแรก")]),_vm._v(" "),_c('v-btn',{staticClass:"primary darken-4 mt-5",attrs:{"round":"","dark":""},nativeOn:{"click":function($event){return _vm.editData.apply(null, arguments)}}},[_vm._v("แก้ไข")])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test3_vue__ = __webpack_require__(65);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bb29d20_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_test3_vue__ = __webpack_require__(179);
function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6bb29d20"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_test3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bb29d20_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_test3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-content',{staticClass:"centerDiv"},[_c('section',[_c('v-layout',{staticClass:"white--text border",attrs:{"column":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v("ชื่อผู้ถือหุ้น")]),_vm._v(" "),_c('h1',{staticClass:"white--text mb-2 text-xs-center"},[_vm._v("ชื่อวาระ (แสดงชื่อย่อ)")]),_vm._v(" "),_c('div',{staticClass:"subheading mb-3 text-xs-center"},[_vm._v("จำนวนหุ้น")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"mt-5 mb-5"},[_vm._v("ลงคะแนน : บัตรเสีย")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-btn',{staticClass:"success darken-4 mr-2 mt-5",attrs:{"loading":_vm.loading4,"disabled":_vm.loading4,"round":"","dark":""},nativeOn:{"click":function($event){return _vm.cancel.apply(null, arguments)}}},[_vm._v("กลับไปหน้าแรก")]),_vm._v(" "),_c('v-btn',{staticClass:"primary darken-4 mt-5",attrs:{"round":"","dark":""},nativeOn:{"click":function($event){return _vm.editData.apply(null, arguments)}}},[_vm._v("แก้ไข")])],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Presentation_vue__ = __webpack_require__(66);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2574dc5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Presentation_vue__ = __webpack_require__(182);
function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2574dc5e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Presentation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2574dc5e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Presentation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[(_vm.isLoading)?_c('div',{staticClass:"mt-5 text-xs-center"},[_c('v-progress-circular',{attrs:{"size":70,"width":5,"indeterminate":"","color":"primary"}})],1):_c('div',{staticClass:"image"},[_c('div',{staticClass:"text"},[_c('v-content',[(_vm.page == 1)?_c('div',[_c('v-layout',{staticClass:"white--text",staticStyle:{"margin-bottom":"10%"},attrs:{"column":"","align-center":""}},[_c('img',{staticClass:"mb-4",attrs:{"src":"/static/img/icons/logo.png","height":"150"}}),_vm._v(" "),_c('h1',{staticClass:"mb-4 display-1 text-xs-center",staticStyle:{"font-weight":"700","font-size":"45px!important"}},[_vm._v(_vm._s(_vm.meetingInfo.titleEN))]),_vm._v(" "),_c('div',{staticClass:"subheading text-xs-center",staticStyle:{"font-weight":"700","font-size":"40px!important"}},[_vm._v(_vm._s(_vm.meetingInfo.title))]),_vm._v(" "),_c('div',{staticClass:"subheading text-xs-center",staticStyle:{"font-weight":"700","font-size":"24px!important","margin-top":"1.5em"}},[_vm._v("บริษัท อินเทอร์เน็ตประเทศไทย จำกัด (มหาชน)")])])],1):_vm._e(),_vm._v(" "),(_vm.page == 2)?_c('div',[_c('v-content',{staticStyle:{"padding":"0px","margin":"0px auto","width":"95%","height":"100%"}},[_c('section',[_c('v-layout',{staticClass:"border",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"black--text",staticStyle:{"font-size":"40px","margin-bottom":"30px"}},[_vm._v("ผู้ถือหุ้น")])]),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":""}},[_c('v-layout',{staticClass:"pl-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('h2',{staticClass:"mr-5 black--text meetingInfoFont"},[_vm._v("จำนวนหุ้นทั้งหมด")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('h2',{staticClass:"black--text f-r meetingInfoFont"},[_vm._v(_vm._s(_vm.setQShare(_vm.meetingInfo.allQShare)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('h2',{staticClass:"pl-4 meetingInfoFont"},[_vm._v("หุ้น")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":""}},[_c('v-layout',{staticClass:"pl-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('h2',{staticClass:"mr-5 black--text meetingInfoFont"},[_vm._v("จำนวนผู้ถือหุ้น")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('h2',{staticClass:"black--text f-r meetingInfoFont"},[_vm._v(_vm._s(_vm.setQShare(_vm.meetingInfo.countMember)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('h2',{staticClass:"pl-4 meetingInfoFont"},[_vm._v("ราย")])])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"my-4"}),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":""}},[_c('v-layout',{staticClass:"pl-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('h2',{staticClass:"mr-5 black--text meetingInfoFont"},[_vm._v("จำนวนหุ้นที่ลงทะเบียน")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('h2',{class:_vm.setColor(_vm.meetingInfo.allQShare_registered, 'qshare')},[_vm._v(_vm._s(_vm.setQShare(_vm.meetingInfo.allQShare_registered)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('h2',{staticClass:"pl-4 meetingInfoFont"},[_vm._v("หุ้น")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":""}},[_c('v-layout',{staticClass:"pl-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('h2',{staticClass:"mr-5 black--text meetingInfoFont"},[_vm._v("คิดเป็นร้อยละ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('h2',{staticClass:"black--text f-r meetingInfoFont"},[_vm._v(_vm._s(_vm.setPercent(_vm.meetingInfo.allQShare_registered_percent, 'agenda')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":""}},[_c('v-layout',{staticClass:"pl-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('h2',{staticClass:"mr-5 black--text meetingInfoFont"},[_vm._v("จำนวนผู้ลงทะเบียน")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('h2',{class:_vm.setColor(_vm.meetingInfo.countMember_registered, 'member')},[_vm._v(_vm._s(_vm.setQShare(_vm.meetingInfo.countMember_registered)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('h2',{staticClass:"pl-4 meetingInfoFont"},[_vm._v("ราย")])])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-3",attrs:{"xs12":""}},[_c('v-layout',{staticClass:"pl-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('h2',{staticClass:"black--text meetingInfoFont"},[_c('li',[_vm._v("ผู้มาลงคะแนนด้วยตัวเอง")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('h2',{staticClass:"black--text f-r meetingInfoFont"},[_vm._v(_vm._s(_vm.setQShare(_vm.meetingInfo.countMember_registered_self)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('h2',{staticClass:"pl-4 meetingInfoFont"},[_vm._v("ราย")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('h2',{staticClass:"black--text f-r meetingInfoFont"},[_vm._v(_vm._s(_vm.setQShare(_vm.meetingInfo.sumQShare_Member_registered_self)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('h2',{staticClass:"pl-4 meetingInfoFont"},[_vm._v("หุ้น")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('h2',{staticClass:"pl-4 meetingInfoFont"},[_vm._v("คิดเป็นร้อยละ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('h2',{staticClass:"black--text f-r meetingInfoFont"},[_vm._v(_vm._s(_vm.setPercent(_vm.meetingInfo.QShare_registered_self_percent, 'agenda')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mb-1",attrs:{"xs12":""}},[_c('v-layout',{staticClass:"pl-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('h2',{staticClass:"black--text meetingInfoFont"},[_c('li',[_vm._v("ผู้มอบฉันทะ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('h2',{staticClass:"black--text f-r meetingInfoFont"},[_vm._v(_vm._s(_vm.setQShare(_vm.meetingInfo.countMember_registered_proxy)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('h2',{staticClass:"pl-4 meetingInfoFont"},[_vm._v("ราย")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('h2',{staticClass:"black--text f-r meetingInfoFont"},[_vm._v(_vm._s(_vm.setQShare(_vm.meetingInfo.sumQShare_Member_registered_proxy)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('h2',{staticClass:"pl-4 meetingInfoFont"},[_vm._v("หุ้น")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('h2',{staticClass:"pl-4 meetingInfoFont"},[_vm._v("คิดเป็นร้อยละ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('h2',{staticClass:"black--text f-r meetingInfoFont"},[_vm._v(_vm._s(_vm.setPercent(_vm.meetingInfo.QShare_registered_proxy_percent, 'agenda')))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}})],1)],1)],1)],1)],1)])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.agendaVote),function(item,index){return (_vm.page == (3 + index))?_c('div',[(item.agenda != '')?_c('v-content',{staticStyle:{"padding":"0px","margin":"0px auto","width":"95%","height":"100%"}},[_c('section',[_c('v-layout',{staticClass:"border",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"black--text mb-2",staticStyle:{"font-size":"33px"},domProps:{"innerHTML":_vm._s('วาระที่ '+ item.agenda + ' ' + item.title)}})]),_vm._v(" "),(item.imagepath)?_c('img',{staticClass:"mb-4",staticStyle:{"display":"block","margin":"0 auto"},attrs:{"src":'/static/img/icons/' + item.imagepath,"height":"230"}}):_vm._e(),_vm._v(" "),_c('table',{staticStyle:{"width":"100%","text-align":"center"}},[_c('tr',[_c('td',{staticStyle:{"text-align":"left","margin-bottom":"50px"}},[_c('h2',[_vm._v("เห็นด้วย")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h2',[_vm._v(_vm._s(_vm.setQShare(item.accept)))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","padding-left":"10px"}},[_c('h2',[_vm._v("หุ้น")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h2',[_vm._v(_vm._s(_vm.setPercent(item.percent_accept, 'agenda'))+" %")])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_c('h2',[_vm._v("ไม่เห็นด้วย")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h2',[_vm._v(_vm._s(_vm.setQShare(item.noaccept)))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","padding-left":"10px"}},[_c('h2',[_vm._v("หุ้น")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h2',[_vm._v(_vm._s(_vm.setPercent(item.percent_noaccept, 'agenda'))+" %")])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_c('h2',[_vm._v("งดออกเสียง")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h2',[_vm._v(_vm._s(_vm.setQShare(item.abstain)))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","padding-left":"10px"}},[_c('h2',[_vm._v("หุ้น")])]),_vm._v(" "),(item.presentationtype == 2 || item.presentationtype == 4)?_c('td',{staticStyle:{"text-align":"right"}},[_c('h2',[_vm._v(_vm._s(_vm.setPercent(item.percent_abstain, 'agenda'))+" %")])]):_vm._e()]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_c('h2',[_vm._v("บัตรเสีย")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h2',[_vm._v(_vm._s(_vm.setQShare(item.broke)))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","padding-left":"10px"}},[_c('h2',[_vm._v("หุ้น")])]),_vm._v(" "),(item.presentationtype == 1 || item.presentationtype == 2)?_c('td',{staticStyle:{"text-align":"right"}},[_c('h2',[_vm._v(_vm._s(_vm.setPercent(item.percent_broke, 'agenda'))+" %")])]):_vm._e()])])],1)],1)],1)]):_c('v-content',{staticStyle:{"padding":"0px","margin":"0px auto","width":"95%","height":"100%"}},[_c('section',[_c('v-layout',{staticClass:"border",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',{staticClass:"black--text mb-2",staticStyle:{"font-size":"33px"},domProps:{"innerHTML":_vm._s(item.agenda + ' ' + item.title)}})]),_vm._v(" "),(item.imagepath)?_c('img',{staticClass:"mb-4",staticStyle:{"display":"block","margin":"0 auto"},attrs:{"src":'/static/img/icons/' + item.imagepath,"height":"230"}}):_vm._e(),_vm._v(" "),_c('table',{staticStyle:{"width":"100%","text-align":"center"}},[_c('tr',[_c('td',{staticStyle:{"text-align":"left","margin-bottom":"50px"}},[_c('h2',[_vm._v("เห็นด้วย")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h2',{class:_vm.setColorVote(item.accept, 'qshare')},[_vm._v(_vm._s(_vm.setQShare(item.accept)))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","padding-left":"10px"}},[_c('h2',[_vm._v("หุ้น")])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_c('h2',[_vm._v("ไม่เห็นด้วย")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h2',[_vm._v(_vm._s(_vm.setQShare(item.noaccept)))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","padding-left":"10px"}},[_c('h2',[_vm._v("หุ้น")])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_c('h2',[_vm._v("งดออกเสียง")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h2',[_vm._v(_vm._s(_vm.setQShare(item.abstain)))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","padding-left":"10px"}},[_c('h2',[_vm._v("หุ้น")])])]),_vm._v(" "),_c('tr',[_c('td',{staticStyle:{"text-align":"left"}},[_c('h2',[_vm._v("บัตรเสีย")])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h2',[_vm._v(_vm._s(_vm.setQShare(item.broke)))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left","padding-left":"10px"}},[_c('h2',[_vm._v("หุ้น")])])])])],1)],1)],1)])],1):_vm._e()}),_vm._v(" "),(_vm.page == (3 + _vm.agendaVote.length))?_c('div',[_c('v-layout',{staticClass:"white--text",staticStyle:{"margin-bottom":"15%"},attrs:{"column":"","align-center":"","justify-center":""}},[_c('img',{staticClass:"mb-4",attrs:{"src":"/static/img/icons/logo.png","height":"150"}}),_vm._v(" "),_c('h1',{staticClass:"white--text mb-4 display-1 text-xs-center"},[_vm._v(_vm._s(_vm.meetingInfo.titleEN))]),_vm._v(" "),_c('div',{staticClass:"white--text subheading text-xs-center"},[_vm._v(_vm._s(_vm.meetingInfo.title))])])],1):_vm._e(),_vm._v(" "),_c('v-footer',{staticStyle:{"background-color":"green"}},[_c('v-flex',{attrs:{"xs6":"","pl-3":"","text-xs-left":"","white--text":""}},[_vm._v("\n            © "+_vm._s(new Date().getFullYear())+" Internet Thailand Public Company Limited\n            ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","text-xs-right":"","pr-3":""}},[_vm._v("\n            "+_vm._s(_vm.setDate)+"\n          ")])],1)],2)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRScanerWeb_vue__ = __webpack_require__(67);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6ff1d3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRScanerWeb_vue__ = __webpack_require__(185);
function injectStyle (ssrContext) {
  __webpack_require__(184)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1d6ff1d3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_QRScanerWeb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d6ff1d3_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_QRScanerWeb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"regiterationLayout text-xs-center"},[_c('h1',{staticStyle:{"font-weight":"900","font-size":"2.5em"}},[_vm._v("สแกนบัตรลงคะแนน")]),_vm._v(" "),_c('v-layout',{staticClass:"mt-4",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":""}},[_c('h2',[_vm._v("ค้นหา")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":""}},[_c('v-text-field',{attrs:{"autofocus":"","placeholder":"สแกนบัตรลงคะแนนที่นี่","autocomplete":"","hint":"กรณีท่านต้องป้อนข้อมูลผ่านคีย์บอร์ด กรุณากรอกตัวเลขให้ครบถ้วน"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submit('/vote/w')}},model:{value:(_vm.qrcodefullid),callback:function ($$v) {_vm.qrcodefullid=$$v},expression:"qrcodefullid"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-btn',{attrs:{"round":"","color":"primary"},on:{"click":function($event){return _vm.submit('/vote/w')}}},[_vm._v("Submit")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-btn',{attrs:{"round":"","color":"primary"},on:{"click":function($event){return _vm.reset()}}},[_vm._v("Reset")])],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 186 */,
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_QRCode_vue__ = __webpack_require__(73);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_36f43883_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_QRCode_vue__ = __webpack_require__(214);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_QRCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_36f43883_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_QRCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[74]);


// WEBPACK FOOTER //
// static/js/app.98e7dc960d32ea7334a8.js